export default {
  首页: "Koti",
  资产: "Varat",
  币币: "Spot",
  快捷买币: "Osta kryptoja nopeasti",
  "支持多种方式购买，购买更简单": "Osta helposti useilla maksutavoilla",
  语言设置: "Kieliasetukset",
  确认恢复: "Vahvista palautus",
  "输入邮箱，方便我们联系您":
    "Anna sähköpostiosoitteesi, jotta voimme ottaa sinuun yhteyttä",
  划转: "Siirrä",
  行情: "Markkinat",
  "24H成交": "24h volyymi",
  累计收益: "Kokonaistuotto",
  充值时间: "Talletuspäivä",
  到期时间: "Erääntymispäivä",
  数量: "Määrä",
  操作: "Toiminto",
  资产信息: "Varatiedot",
  复制地址: "Kopioi osoite",
  链名称: "Ketjun nimi",
  充值地址: "Talletusosoite",
  收款地址: "Vastaanottajan osoite",
  账单: "Lasku",
  提现金额: "Nostosumma",
  接收地址: "Vastaanottajan osoite",
  交易密码: "Kaupankäyntisalasana",
  提现全部: "Nosta kaikki",
  保存图片: "Tallenna kuva",
  输入您的交易密码: "Anna kaupankäyntisalasanasi",
  确定: "Vahvista",
  地址: "Osoite",
  注册时间: "Rekisteröitymispäivä",
  取消: "Peruuta",
  是否划转: "Siirrä?",
  登录: "Kirjaudu sisään",
  我的地址: "Omat osoitteet",
  登录密码和交易密码: "Kirjautumissalasana ja kaupankäyntisalasana",
  注册: "Rekisteröidy",
  密码: "Salasana",
  设置密码: "Aseta salasana",
  重复密码: "Toista salasana",
  新密码: "Uusi salasana",
  确认新密码: "Vahvista uusi salasana",
  充值: "Talleta",
  充值货币: "Talleta valuuttaa",
  合约账户充值: "Talleta futuuritilille",
  账户充值: "Talleta tilille",
  其他: "Muut",
  我的邀请码: "Minun kutsukoodini",
  提现: "Nosta",
  客服: "Asiakaspalvelu",
  持有详情: "Omistuksen tiedot",
  请输入内容: "Anna sisältö",
  邀请好友来领取奖励: "Kutsu ystäviä ja vastaanota palkintoja",
  复制链接: "Kopioi linkki",
  重复设置新的密码: "Toista uusi salasana",
  保存: "Tallenna",
  我的: "Oma tili",
  "邮箱/手机号": "Sähköposti/Matkapuhelinnumero",
  备注: "Huomautus",
  地址管理: "Osoitehallinta",
  我的团队: "Tiimini",
  联系我们: "Ota yhteyttä",
  竭诚为您服务: "Olemme palveluksessasi",
  提取收益: "Nosta tuotto",
  带给我的收益: "Tuotettu tuotto",
  添加: "Lisää",
  名称: "Nimi",
  添加地址: "Lisää osoite",
  修改地址: "Muokkaa osoitetta",
  可提现: "Nostettavissa",
  安全中心: "Turvakeskus",
  收益划转: "Siirrä tuotto",
  通知中心: "Ilmoitukset",
  "累计收益:": "Kokonaistuotto:",
  注册用户: "Rekisteröityneet käyttäjät",
  奖励规则: "Palkintosäännöt",
  帮助反馈: "Apua ja palautetta",
  邀请好友: "Kutsu ystäviä",
  恢复身份: "Palauta henkilöllisyys",
  选择语言: "Valitse kieli",
  设置新的密码: "Aseta uusi salasana",
  暂无活动: "Ei aktiivisia aktiviteetteja",
  "月增长量(+)": "Kuukausittainen kasvu (+)",
  可提取: "Nostettavissa",
  反馈类型: "Palautetyyppi",
  赠送: "Lahja",
  已经复制: "Kopioitu",
  保存成功: "Tallennettu",
  划转成功: "Siirto onnistui",
  过期: "Vanhentunut",
  提交成功: "Lähetetty",
  "服务器繁忙，稍后在试": "Palvelin on varattu, yritä myöhemmin uudelleen",
  全部: "Kaikki",
  一级: "Taso 1",
  二级: "Taso 2",
  三级: "Taso 3",
  级: "Taso",
  删除成功: "Poistettu",
  选择地址: "Valitse osoite",
  不再提醒: "Älä näytä uudelleen",
  "最小充值金额：": "Minimitalletussumma:",
  选择币种: "Valitse kryptovaluutta",
  输入投资金额: "Syötä sijoitusmäärä",
  输入账户密码: "Syötä tilin salasana",
  投资: "Sijoita",
  订单编号: "Tilausnumero",
  投资周期: "Sijoitusjakso",
  投资资金: "Sijoitettu summa",
  投资时间: "Sijoitusajankohta",
  状态: "Tila",
  投资中: "Aktiivinen",
  已到期: "Vanhentunut",
  暂无数据: "Ei tietoja",
  转入: "Siirrä tilille",
  邮箱: "Sähköposti",
  请输入邮箱: "Syötä sähköpostiosoite",
  请输入格式正确的邮箱: "Syötä kelvollinen sähköpostiosoite",
  请输入验证码: "Syötä vahvistuskoodi",
  获取验证码: "Hae vahvistuskoodi",
  请输入邀请码: "Syötä kutsukoodi",
  今天: "Tänään",
  昨天: "Eilen",
  最近七天: "Viimeiset 7 päivää",
  邀请: "Kutsu",
  购买数量: "Ostomäärä",
  产品详情: "Tuotetiedot",
  币种: "Kryptovaluutta",
  利息币种: "Tuottovaluutta",
  理财类型: "Sijoituskohteen tyyppi",
  产品费率: "Tuotteen maksut",
  进行中: "Aktiivinen",
  每天: "Päivittäin",
  请输入搜索关键词: "Syötä hakusana",
  通知: "Ilmoitukset",
  查看更多: "Katso lisää",
  理财宝: "Sijoituskohteet",
  周期: "Kesto",
  年利率: "Vuosikorko (APY)",
  更多产品: "Lisää tuotteita",
  灵活存取: "Joustava säästäminen",
  稳定收益: "Vakaa tuotto",
  合约指南: "Futuurien opas",
  资金划转出: "Lähtevä siirto",
  矿池收益: "Louhintapalkkio",
  提现手续费: "Nostomaksu",
  冻结资金: "Jäädytetyt varat",
  解冻资金: "Vapauta jäädytetyt varat",
  闪兑支出: "Pikavaihdon kulu",
  闪兑收入: "Pikavaihdon tuotto",
  闪兑手续费: "Pikavaihdon maksu",
  合约支出: "Futuurien kulu",
  合约收入: "Futuurien tuotto",
  输入的金额不可大于可用金额:
    "Summa ei saa ylittää käytettävissä olevaa summaa",
  全部兑换成功: "Täydellinen vaihto onnistui",
  返回: "Takaisin",
  查看历史: "Katso historia",
  闪兑历史: "Pikavaihdon historia",
  支付: "Maksa",
  获取: "Hae",
  时间: "Aika",
  手续费: "Transaktiomaksu",
  折扣: "Alennus",
  价格: "Hinta",
  逐仓: "Eristetty vakuus",
  全仓: "Ristiinvakuus",
  市价委托: "Markkinatoimeksianto",
  限价委托: "Limit-toimeksianto",
  请输入本金: "Syötä pääoma",
  请输入价格: "Syötä hinta",
  "可做空/做多": "Mahdollista lyhyeksi-/pitkäksi myynti",
  设置止盈止损: "Aseta voitonotto/tappionrajoitus",
  止盈价: "Voitonoton hinta",
  止损价: "Tappionrajoituksen hinta",
  成本: "Hankintahinta",
  做多: "Pitkä (Long)",
  做空: "Lyhyt (Short)",
  仓位信息: "Positiotiedot",
  一键平仓: "Sulje positio (yhdellä napsautuksella)",
  永续: "Ikuinen",
  浮动盈亏: "Toteutumaton voitto/tappio",
  平仓: "Sulje positio",
  反向开仓: "Avaa käänteinen positio",
  一键撤销: "Peruuta kaikki (yhdellä napsautuksella)",
  倍杠杆: "kertainen vipuvaikutus",
  执行价格: "Toteutushinta",
  委托数量: "Toimeksiannon määrä",
  保证金: "Vakuus",
  成交价: "Toteutushinta",
  创建时间: "Luomisaika",
  撤销: "Peruuta",
  合约市场: "Futuurimarkkinat",
  交易方向: "Kaupankäyntisuunta",
  委托价格: "Toimeksiannon hinta",
  委托金额: "Toimeksiannon summa",
  资金费率: "Rahoituskorko",
  "多方和空方交易者支付的定期费用，每8小时结算一次。":
    "Määräaikainen maksu, jonka pitkät ja lyhyet positiot maksavat, selvitetään 8 tunnin välein.",
  "资金费率为正，多方向空方支付资金费用。":
    "Positiivisella rahoituskorolla pitkät positiot maksavat lyhyille positioille.",
  "资金费率为负，空方向多方支付资金费用。":
    "Negatiivisella rahoituskorolla lyhyet positiot maksavat pitkille positioille.",
  "确定反向开仓吗？反向开仓将以当期相反 的仓位进行买入":
    "Oletko varma, että haluat avata käänteisen position? Tämä ostaa nykyisen position vastakkaisen suunnan.",
  "仓位止盈/止损": "Position voitonotto/tappionrajoitus",
  合约名称: "Futuurisopimus",
  开仓价格: "Avaushinta",
  指数价格: "Indeksihinta",
  止盈设置: "Voitonoton asetukset",
  请输入止盈价: "Syötä voitonoton hinta",
  "当指数价格触达*时，将会触发委托平仓":
    "Kun indeksihinta saavuttaa *, sulkemistoimeksianto laukeaa.",
  预计盈亏: "Odotettu voitto/tappio",
  当前仓位: "Nykyinen positio",
  平仓金额: "Sulkemissumma",
  仓位模式: "Positiotila",
  全仓模式: "Ristiinvakuustila",
  "合约账户中的所有可用资金视作为可用保证金， 当仓位亏损超过了账户余额才会爆仓强平，并将损失所有 保证金和仓位，请注意":
    "Ristiinvakuustilassa kaikkia futuuritilisi käytettävissä olevia varoja käytetään vakuutena. Likvidointi tapahtuu, kun tappio ylittää kokonaissaldosi, mikä johtaa koko vakuuden ja position menetykseen.",
  逐仓模式: "Eristetty vakuustila",
  "会使合约账户中的一定数量保证金被分配到仓位上。如果保证金亏损低于维持保证金的水平，仓位被强平。在逐仓模式下，您可以为这个仓位增加和减少保证金。":
    "Tietty määrä vakuutta osoitetaan positiolle. Jos vakuustappio putoaa alle ylläpitovakuuden tason, positio likvidoidaan. Voit lisätä tai vähentää vakuutta tälle positiolle.",
  "是否撤销？": "Peruutetaanko toimeksianto?",
  "是否一键撤销？": "Peruutetaanko kaikki toimeksiannot?",
  "是否一键平仓？": "Suljetaanko kaikki positiot?",
  持仓保证金: "Nykyisen position vakuus",
  风险率: "Riskiprosentti",
  未实现盈亏: "Toteutumaton voitto/tappio",
  可用保证金: "Käytettävissä oleva vakuus",
  净值: "Nettovarallisuus",
  账户余额: "Tilin saldo",
  合约计算器: "Futuurilaskin",
  交易记录: "Tapahtumahistoria",
  "*倍杠杆": "*kertainen vipuvaikutus",
  "平仓盈亏：": "Toteutunut voitto/tappio:",
  时间筛选: "Aikasuodatin",
  仓位类型: "Positiotyyppi",
  订单状态: "Tilauksen tila",
  订单类型: "Toimeksiantotyyppi",
  平仓价格: "Sulkemishinta",
  持仓数量: "Position määrä",
  "手续费(%)": "Transaktiomaksu (%)",
  平仓时间: "Sulkemisaika",
  平仓类型: "Sulkemistyyppi",
  手动平仓: "Manuaalinen sulkeminen",
  强制平仓: "Pakkolikvidointi",
  近1天: "Viimeinen päivä",
  近7天: "Viimeiset 7 päivää",
  近30天: "Viimeiset 30 päivää",
  近180天: "Viimeiset 180 päivää",
  持仓: "Avoin positio",
  已取消: "Peruttu",
  分时: "Päivänsisäinen",
  "24H额(USDT)": "24h volyymi (USDT)",
  "24H低": "24h alin",
  "24H量(BTC)": "24h volyymi (BTC)",
  "24H高": "24h korkein",
  "10秒": "10 sekuntia",
  "30秒": "30 sekuntia",
  "1分": "1 minuutti",
  "3分": "3 minuuttia",
  "5分": "5 minuuttia",
  "30分": "30 minuuttia",
  "1小时": "1 tunti",
  "4小时": "4 tuntia",
  "8小时": "8 tuntia",
  "1天": "1 päivä",
  "1周": "1 viikko",
  "1月": "1 kuukausi",
  单向持仓: "Yksisuuntainen positio",
  杠杆: "Vipuvaikutus",
  仓位: "Positio",
  计算结果: "Tulos",
  盈亏: "Voitto/Tappio",
  收益率: "Tuotto",
  计算结果仅供参考: "Tulos on suuntaa-antava",
  成交后仓位大小: "Position koko toteutuksen jälkeen",
  "计算结果仅供参考,实际结果可能因费率差异":
    "Tulos on suuntaa-antava, todelliset tulokset voivat vaihdella maksujen vuoksi.",
  目标价格: "Tavoitehinta",
  开始计算: "Laske",
  强平价格: "Likvidointihinta",
  "充值前，请认真核对充值的链名称，充值错误无法找回资产*最小充值金额为*；少于此金额平台将无法确认到账，请不要向此地址充值*之外的资产，否则将无法找回资产，请不要直接提现众筹或者ICO地址，平台不会代理币的发放。":
    "Tarkista ketjun nimi huolellisesti ennen tallettamista. Virheellisiä talletuksia ei voi peruuttaa. Minimitalletussumma on *. Tämän alittavia talletuksia ei käsitellä. Älä lähetä muita varoja tähän osoitteeseen. Älä käytä ICO- tai joukkorahoitusosoitteita nostoihin.",
  "最小输入*": "Vähintään {0}",
  "最小提币数量为*，提币手续费将从你的提款金额中扣除。提币前请确认核对收款地址，不要将*提现至*以外的地址，否则无法找回资产。请不要直接提现众筹或者ICO地址，平台不会处理代币的发放。":
    "Minimi nostomäärä on *. Nostomaksut vähennetään nostosumman jälkeen. Tarkista vastaanottajan osoite huolellisesti. Älä lähetä * osoitteisiin *. Älä käytä ICO- tai joukkorahoitusosoitteita.",
  退出登录: "Kirjaudu ulos",
  加仓: "Lisää positiota",
  新增仓位: "Uusi positio",
  输入加仓金额: "Syötä summa position lisäämiseksi",
  "当前可用:": "Tällä hetkellä käytettävissä:",
  资产账单: "Varojen lasku",
  保存二维码: "Tallenna QR-koodi",
  温馨提示: "Huomautus",
  "请注意：您当前使用的网络": "Huomautus: Käytät tällä hetkellä verkkoa",
  输入提现地址: "Syötä nosto-osoite",
  "可用金额：": "Käytettävissä oleva summa:",
  输入资产密码: "Syötä varojen salasana",
  可用手续费: "Käytettävissä oleva maksu",
  "折扣%": "Alennus %",
  实扣手续费: "Tosiasiallisesti veloitettu maksu",
  实际到账: "Tosiasiallisesti vastaanotettu summa",
  未设置资产密码: "Varojen salasanaa ei ole asetettu",
  "为了您的资产安全，请设置资产密码后再来提现。":
    "Aseta turvallisuutesi vuoksi varojen salasana ennen nostoa.",
  热榜: "Suositut",
  涨幅榜: "Suurimmat nousut",
  跌幅榜: "Suurimmat laskut",
  成交额榜: "Volyymilista",
  关于我们: "Meistä",
  登录密码: "Kirjautumissalasana",
  设置: "Asetukset",
  资产密码: "Varojen salasana",
  修改登录密码: "Vaihda kirjautumissalasana",
  原密码: "Vanha salasana",
  请输入新密码: "Syötä uusi salasana",
  请输入原密码: "Syötä vanha salasana",
  确认密码: "Vahvista salasana",
  确定修改: "Vahvista muutos",
  修改资产密码: "Vaihda varojen salasana",
  验证码: "Vahvistuskoodi",
  资产密码使用提示: "Varojen salasanan vinkit",
  "资产密码用于转移、提取资产和交易。":
    "Varojen salasanaa käytetään varojen siirtämiseen, nostamiseen ja kaupankäyntiin.",
  "创建与登录密码不同的资产密码。":
    "Luo varojen salasana, joka on eri kuin kirjautumissalasanasi.",
  "定期更改您的资产密码。": "Vaihda varojen salasanasi säännöllisesti.",
  提币历史: "Nostohistoria",
  "金额/余额": "Summa/Saldo",
  "手续费/折扣": "Maksu/Alennus",
  自选: "Suosikit",
  现货: "Spot",
  市价: "Markkinahinta",
  止损设置: "Tappionrajoituksen asetukset",
  合约K线图: "Futuurien kaavio",
  "24H量": "24h volyymi",
  "24H额": "24h volyymi (USDT)",
  合作指南: "Kumppanuusopas",
  盈亏计算: "Voiton/tappion laskenta",
  当前可用: "Tällä hetkellä käytettävissä",
  请输入加仓金额: "Syötä summa position lisäämiseksi",
  请重新输入加仓金额: "Syötä position lisäyssumma uudelleen",
  平仓数量: "Suljettava määrä",
  欢迎登录: "Tervetuloa takaisin",
  "忘记密码?": "Unohditko salasanan?",
  "还没有账号？": "Eikö sinulla ole tiliä?",
  立即注册: "Rekisteröidy nyt",
  繁體中文: "Perinteinen kiina",
  找回密码: "Palauta salasana",
  下一步: "Seuraava",
  注册账户: "Rekisteröi tili",
  "请输入邀请码(选填)": "Syötä kutsukoodi (valinnainen)",
  谢邀豪礼: "Kutsubonus",
  "24小时邀请好友排名": "24 tunnin kutsusijoitus",
  "*人": "* henkilöä",
  "差*人": "Puuttuu * henkilöä",
  "已超过10万人，每月轻松赚钱":
    "Yli 100 000 käyttäjää, ansaitse rahaa helposti joka kuukausi",
  最高: "Maksimi",
  邀请链接: "Kutsulinkki",
  "平台和您共享好友在平台（现货、合约、杠杆、闪兑）所产生的手续费":
    "Jaa ystäviesi tuottamissa transaktiomaksuissa (spot, futuurit, vipuvaikutus, pikavaihto).",
  平台和您一起分享手续费: "Jaa transaktiomaksut alustan kanssa",
  "*级": "* taso",
  规则: "Säännöt",
  我的好友: "Ystäväni",
  好友详情: "Ystävän tiedot",
  获得好友佣金方案: "Ystäväprovisiosuunnitelma",
  我的等级: "Oma taso",
  我的邀请数据: "Kutsutilastoni",
  当前等级: "Nykyinen taso",
  平台奖励您: "Alustan palkinto sinulle",
  最高可获取平台奖励: "Suurin mahdollinen alustan palkinto",
  邀请规则: "Kutsumissäännöt",
  "邀请*级有效好友": "Kutsu aktiivisia ystäviä tasolla *",
  好友等级: "Ystävän taso",
  人: "henkilöä",
  奖金派送: "Bonuksen maksu",
  平台奖励: "Alustan palkinto",
  "最终解释权归平台所有，若发现异常获取平台奖励，将会扣除所有的奖励，并且冻结账户，资产的损失将无法找回。":
    "Alusta pidättää oikeuden lopulliseen tulkintaan. Petollisen toiminnan yhteydessä palkinnot peruutetaan ja tilisi jäädytetään. Menetetyt varat eivät ole palautettavissa.",
  "您的账户必须是有效账户，平台判定有效账户条件为（账户充值任何币种）最小* USDT的价值。":
    "Tilisi on oltava aktiivinen, mikä määritellään vähintään * USDT:n arvoisena talletuksena missä tahansa kryptovaluutassa.",
  "您邀请的好友，必须是有效下级，平台判定有效下级为（账户充值任何币种）最小* USDT的价值。":
    "Kutsumasi ystävän on oltava aktiivinen alarivi, määriteltynä vähintään * USDT:n arvoisena talletuksena.",
  "邀请人和被邀请者的账号不能同属于一个IP。":
    "Kutsuja ja kutsuttu eivät voi jakaa samaa IP-osoitetta.",
  "VIP等级由您邀请的*级好友的人数作为考核。":
    "VIP-taso määräytyy kutsuttujen ystävien lukumäärän mukaan tasolla *.",
  佣金成分: "Provisiokomponentit",
  收益统计: "Tuottotilastot",
  昨日收益: "Eilinen tuotto",
  月收益: "Kuukausituotto",
  获取收益: "Hae tuotto",
  "总收益：": "Kokonaistuotto:",
  "*级好友": "Tason * ystävät",
  理财购买: "Osta sijoituskohde",
  期限: "Kesto",
  可用金额: "Käytettävissä oleva summa",
  预估收益: "Arvioitu tuotto",
  申购上限: "Maksimi osto",
  项目剩余: "Jäljellä oleva projekti",
  "买入后预计*(SGT)开始计算收益。":
    "Tuoton odotetaan alkavan kertyä noin *(SGT) oston jälkeen.",
  计息日: "Koron alkamispäivä",
  申购日: "Ostopäivä",
  到账日: "Hyvityspäivä",
  到期自动续投: "Automaattinen uudelleensijoitus erääntyessä",
  申购: "Osta",
  搜索理财项目: "Etsi sijoituskohdetta",
  超高年化随心选: "Valitse korkean tuoton tuotteista",
  "自由选择理财币种，稳定超额收益":
    "Valitse vapaasti kryptovaluuttasi vakaalle, keskiarvoa korkeammalle tuotolle",
  理财总资产: "Sijoitetut varat yhteensä",
  申购数量: "Ostettava määrä",
  立即购买: "Osta heti",
  年化收益率: "Vuotuinen prosentuaalinen tuotto (APY)",
  理财订单: "Sijoituskohteen tilaukset",
  持有: "Omistuksessa",
  申购份额: "Ostettu osuus",
  到账日期: "Hyvityspäivä",
  申购成功: "Osto onnistui",
  到期: "Vanhentunut",
  是否选择做多: "Avataanko pitkä positio?",
  "可用余额为0 不能操作": "Saldo on 0, toiminto ei ole mahdollinen",
  福利中心: "Bonuskeskus",
  奖励记录: "Palkintohistoria",
  我获取到的奖励: "Ansaitsemani palkinnot",
  总价值: "Kokonaisarvo",
  新手任务: "Uusien käyttäjien tehtävät",
  身份认证: "Henkilöllisyyden vahvistus (KYC)",
  身份验证: "Henkilöllisyyden vahvistus",
  去验证: "Vahvista nyt",
  审核中: "Odottaa",
  已验证: "Vahvistettu",
  认证失败: "Vahvistus epäonnistui",
  基础认证: "Perusvahvistus",
  "请注意认证信息一经验证不能修改，务必填写准确信息":
    "Huomautus: Vahvistettuja tietoja ei voi muuttaa. Anna tarkat tiedot.",
  "国家/地区": "Maa/Alue",
  请选择: "Valitse",
  证件类型: "Asiakirjatyyppi",
  证件编码: "Asiakirjan numero",
  身份证: "Henkilökortti",
  护照: "Passi",
  驾驶证: "Ajokortti",
  请输入编码: "Syötä numero",
  名字: "Etunimi",
  请输入: "Anna",
  中间名: "Toinen nimi",
  选填: "Valinnainen",
  姓氏: "Sukunimi",
  中国: "Kiina",
  身份上传: "Lataa henkilöllisyystodistus",
  上传身份证: "Lataa henkilökortti",
  "以上材料需要用JPG/JPEG/PNG格式上传，并且保证照片的清晰边角完整，亮度均匀。且大小不超过*M。":
    "Lataa JPG/JPEG/PNG-muodossa. Varmista, että kuvat ovat selkeitä, täydellisiä ja tasaisesti valaistuja. Enintään *MB.",
  确定提交: "Lähetä",
  去认证: "Vahvista",
  挑战任务: "Haastetehtävät",
  注册认证任务: "Rekisteröinti- ja vahvistustehtävä",
  完成注册认证即可领取: "Suorita rekisteröinti ja vahvistus saadaksesi",
  领取奖励: "Vastaanota palkinto",
  新人豪礼: "Tervetuliaisbonus",
  "参与人数：": "Osallistujien määrä:",
  条件: "Ehto",
  入金量: "Talletussumma",
  完成: "Suoritettu",
  任务奖励: "Tehtäväpalkinto",
  距任务更新: "Tehtävän päivitykseen",
  "条件：": "Ehto:",
  活动规则: "Aktiviteettisäännöt",
  奖励明细: "Palkintotiedot",
  已获得: "Ansaittu",
  交易奖励: "Kaupankäyntipalkinto",
  Win奖励: "WIN-palkinto",
  已领取: "Vastaanotettu",
  亏损金额超过: "Tappion määrä ylittää",
  单笔开仓金额超过: "Yksittäisen toimeksiannon määrä ylittää",
  交易量: "Kaupankäyntivolyymi",
  待完成: "Odottaa",
  入金: "Talletus",
  盈利金额超过: "Voiton määrä ylittää",
  开仓金额: "Toimeksiannon määrä",
  开仓金: "Toimeksiannon määrä",
  盈利: "Voitto",
  亏损: "Tappio",
  领取: "Vastaanota",
  未领取: "Ei vastaanotettu",
  待领取: "Odottaa vastaanottoa",
  再交易: "Jatka kaupankäyntiä",
  即可获得: "saadaksesi",
  领取成功: "Vastaanotettu",
  "1、所有的活动都会按照活动最后的时间进行统计收益过期后将无效。":
    "1. Kaikki aktiviteetit selvitetään päättymispäivänä. Palkinnot vanhenevat sen jälkeen.",
  "2、获得的收益会发放到您的赏金账户中，你可以随时根据您的需要进行兑换和提现。":
    "2. Ansaittu tuotto hyvitetään palkintotilillesi, josta voit vaihtaa tai nostaa sen milloin tahansa.",
  "3、获取的到的奖励币种类型根据任务按类型发放。":
    "3. Palkinnon kryptovaluutta riippuu tehtävästä.",
  "4、最终解释权归平台所有，若发现存在异常手段套利平台的任务奖金，平台有权冻结并且清除您获取的收益。":
    "4. Alusta pidättää oikeuden lopulliseen tulkintaan. Tehtävissä huijaamisen yhteydessä palkinnot pidätetään ja tilisi voidaan jäädyttää.",
  成长学院: "Akatemia",
  "区块链 & 加密货币": "Lohkoketju & Kryptovaluutta",
  "您的加密货币一站式指南，我们带您开启加密货币之路。":
    "Kattava oppaasi kryptovaluuttoihin. Opastamme sinut kryptomatkallasi.",
  "全仓合约定单的全部保证金。":
    "Ristiinvakuuden futuuritoimeksiantojen kokonaisvakuus.",
  "(账户余额+(浮动盈亏-手续费-过夜费)=净值/已用保证金*100":
    "(Saldo + (toteutumaton voitto/tappio - maksut - rahoituskorot) = Nettovarallisuus / Käytetty vakuus * 100",
  "浮动盈亏会直接影响”可用保证金“，当未实现盈亏增加，可用保证金将会增加，未实现盈亏减少，可用保证金同样也会减少。":
    "Toteutumaton voitto/tappio vaikuttaa suoraan 'käytettävissä olevaan vakuuteen'. Jos toteutumaton voitto/tappio kasvaa, käytettävissä oleva vakuus kasvaa ja päinvastoin.",
  "账户余额-(已用保证金)+(浮动盈亏-手续费-过夜费)":
    "Saldo - (Käytetty vakuus) + (toteutumaton voitto/tappio - maksut - rahoituskorot)",
  "注:可继续用于开仓的保证金。":
    "Huomautus: Vakuus, joka on käytettävissä uusien positioiden avaamiseen.",
  "账户余额+(浮动盈亏-手续费-过夜费)":
    "Saldo + (toteutumaton voitto/tappio - maksut - rahoituskorot)",
  "注:当前的资金结余。": "Huomautus: Nykyinen saldo.",
  "指的是合约账户的全部余额，包含不可用余额。":
    "Tarkoittaa futuuritilin kokonaissaldoa, mukaan lukien jäädytetyt summat.",
  "注:风险率越高，风险越低，风险率越低，风险越高。":
    "Huomautus: Mitä korkeampi riskiprosentti, sitä pienempi riski, ja päinvastoin.",
  该功能尚未开发: "Tämä toiminto on vielä kehitteillä",
  重置密码: "Palauta salasana",
  "请输入为8-20位，必须包含字母、数字和特殊字符":
    "Anna 8-20 merkkiä, mukaan lukien kirjaimet, numerot ja erikoismerkit",
  修改成功: "Muutos onnistui",
  输入验证码: "Syötä vahvistuskoodi",
  输入密码: "Syötä salasana",
  详情说明: "Tiedot",
  已售罄: "Loppuunmyyty",
  剩余期限: "Jäljellä oleva aika",
  限期: "Kesto",
  闪兑货币选择: "Valitse valuutta pikavaihtoa varten",
  地区选择: "Valitse alue",
  "搜索国家/地区": "Hae maata/aluetta",
  "身份信息已提交，将在*小时内审核完成":
    "Henkilötiedot lähetetty. Käsittely kestää enintään * tuntia.",
  "选择国家/地区": "Valitse maa/alue",
  "止盈价格需高于*": "Voitonoton hinnan on oltava korkeampi kuin *",
  "止损价格需低于*": "Tappionrajoituksen hinnan on oltava alempi kuin *",
  "止盈价格需低于*": "Voitonoton hinnan on oltava alempi kuin *",
  "止损价格需高于*": "Tappionrajoituksen hinnan on oltava korkeampi kuin *",
  教程详情: "Oppaan tiedot",
  请输入止损价: "Syötä tappionrajoituksen hinta",
  活期: "Joustava",
  赎回后立即到账: "Välitön hyvitys lunastuksen jälkeen",
  赎回: "Lunasta",
  赎回理财: "Lunasta sijoituskohde",
  是否赎回当前的理财订单: "Lunastetaanko nykyinen sijoituskohteen tilaus?",
  维护: "Huolto",
  "系统正在维护中……": "Järjestelmä on huollossa...",
  合约: "Futuurit",
  闪电兑换: "Pikavaihto",
  流水挖矿: "Volyymilouhinta",
  邀请豪礼: "Kutsubonus",
  计算器: "Laskin",
  最新价: "Viimeisin hinta",
  涨跌幅: "Muutos (24h)",
  关注币种添加自选: "Lisää kryptovaluutta suosikkeihin",
  一键添加自选: "Lisää suosikkeihin (yhdellä napsautuksella)",
  全标已读: "Merkitse kaikki luetuksi",
  无消息: "Ei viestejä",
  "暂时还没有收到任何消息通知哦!": "Et ole vielä saanut yhtään ilmoitusta!",
  没有更多数据: "Ei enempää tietoja",
  闪兑: "Pikavaihto",
  从: "Mistä",
  "可用余额：": "Käytettävissä oleva saldo:",
  至: "Mihin",
  预览兑换结果: "Esikatsele vaihdon tulosta",
  闪兑规则: "Pikavaihdon säännöt",
  "市场闪兑可能变动，请以实际到账的金额数量为准。":
    "Pikavaihto on markkinavaihteluiden alaista. Tosiasiallisesti vastaanotettu summa on sitova.",
  "对汇兑率由第三方制定，由于兑换成本以及市场波动，您兑换的汇率可能会高于市场的汇率，请仔细确认后进行操作。":
    "Vaihtokurssit määrittävät kolmannet osapuolet. Kustannusten ja vaihteluiden vuoksi kurssi voi poiketa markkinakurssista. Tarkista huolellisesti.",
  "平台对每笔汇兑收取大约*%的手续费，用于支付在交易所兑换成本。":
    "Alusta veloittaa noin *% maksun vaihtoa kohden kattaakseen kustannukset pörsseissä.",
  确认汇兑: "Vahvista vaihto",
  您预估得到: "Arvioitu saanti",
  汇兑: "Vaihto",
  汇兑比例: "Vaihtokurssi",
  刷新: "Päivitä",
  兑换: "Vaihda",
  没有更多了: "Ei enempää tietoja",
  搜索币种: "Hae kryptovaluuttaa",
  可用: "Käytettävissä",
  我知道了: "Ymmärrän",
  最新价格: "Viimeisin hinta",
  确认: "Vahvista",
  最大: "Maksimi",
  "风险率(%)": "Riskiprosentti (%)",
  当前委托: "Nykyiset toimeksiannot",
  合作交易历史记录: "Kumppanin tapahtumahistoria",
  重置: "Nollaa",
  余额: "Saldo",
  现货账户: "Spot-tili",
  合约账户: "Futuuritili",
  WIN账户: "WIN-tili",
  赏金账户: "Palkintotili",
  总资产折合: "Varat yhteensä (USDT)",
  今日收益: "Tämän päivän tuotto",
  充币: "Talletus",
  提币: "Nosto",
  账户权益: "Tilin arvo",
  "数量/类别": "Määrä/Luokka",
  全部币种: "Kaikki kryptovaluutat",
  全部类型: "Kaikki tyypit",
  账单信息: "Laskun tiedot",
  理财赎回: "Sijoituskohteen lunastus",
  购买理财: "Osta sijoituskohde",
  收入: "Tulot",
  支出: "Menot",
  到: "tilille",
  资产划转: "Varojen siirto",
  "最少*": "Vähintään *",
  "可用资产：": "Käytettävissä olevat varat:",
  确认划转: "Vahvista siirto",
  "只有将资产划转至对于的账户才可以进行交易，账户间的划转不收取手续费。":
    "Sinun on siirrettävä varat oikealle tilille voidaksesi käydä kauppaa. Siirrot tilien välillä ovat maksuttomia.",
  币种账户选择: "Valitse kryptovaluuttatili",
  选择账户: "Valitse tili",
  划转详情: "Siirron tiedot",
  划转明细: "Siirron erittely",
  收入账单: "Tulolasku",
  支出账单: "Menolasku",
  金额: "Summa",
  总收益: "Kokonaistuotto",
  佣金: "Provisio",
  用户名: "Käyttäjätunnus",
  "已领取：": "Vastaanotettu:",
  "未领取：": "Ei vastaanotettu:",
  "请选择国家/地区": "Valitse maa/alue",
  请上传身份信息: "Lataa henkilötiedot",
  请选择证件类型: "Valitse asiakirjatyyppi",
  请填写证件编码: "Syötä asiakirjan numero",
  请填写名字: "Syötä etunimi",
  请填写姓氏: "Syötä sukunimi",
  投资金额: "Sijoitusmäärä",
  天: "päivää",
  请输入手机号: "Syötä matkapuhelinnumero",
  搜索: "Hae",
  搜索历史: "Hakuhistoria",
  热门推荐: "Suositut suositukset",
  "《Xspace Earn协议》": "Xspace Earn -protokolla",
  我已了解并同意: "Ymmärrän ja hyväksyn",
  协议: "Protokolla",
  Xspace官方中文交流群: "Xspace virallinen kiinalainen yhteisö",
  Xspace官方英文交流群: "Xspace virallinen englanninkielinen yhteisö",
  预计维护至: "Arvioitu huolto päättyy",
  更多功能: "Lisää toimintoja",
  下载APP: "Lataa sovellus",
  理财: "Sijoituskohde",
  推荐: "Suositeltu",
  Telegram官方中文频道: "Virallinen Telegram-kanava (kiina)",
  Telegram官方英文频道: "Virallinen Telegram-kanava (englanti)",
  官方邮箱: "Virallinen sähköpostiosoite",
  客服邮箱: "Asiakaspalvelun sähköpostiosoite",
  上述信息最终解释权归官方所有:
    "Yllä olevat tiedot ovat alustan virallisen tulkinnan alaisia.",
  IOS版下载: "Lataa iOS:lle",
  Android版下载: "Lataa Androidille",
  "手续费=买入手续费+资金费率+卖出手续费":
    "Transaktiomaksu = Ostomaksu + Rahoituskorko + Myyntimaksu",
  资金划转: "Varojen siirto",
  止盈: "Voitonotto",
  止损: "Tappionrajoitus",
  自动平仓: "Automaattinen sulkeminen",
  委托挂单: "Avoin toimeksianto",
  买: "Osta",
  卖: "Myy",
  "买入/做多": "Osta/Pitkä",
  "卖出/做空": "Myy/Lyhyt",
  详情: "Tiedot",
  浮动涨跌: "Toteutumaton voitto/tappio",
  最小: "Minimi",
  充币数量: "Talletusmäärä",
  请输入充币数量: "Syötä talletusmäärä",
  支付截图: "Maksukuitti",
  提交: "Lähetä",
  上传驾驶证: "Lataa ajokortti",
  上传护照: "Lataa passi",
  加载中: "Ladataan...",
  上传成功: "Lataus onnistui",
  充值历史: "Talletushistoria",
  合约卖出手续费: "Futuurien myyntimaksu",
  合约买入手续费: "Futuurien ostomaksu",
  系统加款: "Järjestelmän hyvitys",
  系统减款: "Järjestelmän veloitus",
  合约资金费率: "Futuurien rahoituskorko",
  佣金分成: "Provision jakaminen",
  U本位合约: "USDT-vakuuksiset futuurit",
  资产管理: "Varainhoito",
  APP下载: "Lataa sovellus",
  全球领先的数字理财平台: "Maailman johtava digitaalinen varainhoitoalusta",
  "即刻交易比特币、以太坊等上百种数字资产":
    "Käy kauppaa välittömästi Bitcoinilla, Ethereumilla ja sadoilla muilla digitaalisilla varoilla",
  "24H涨跌幅": "24h muutos",
  查看更多行情: "Katso lisää markkinoita",
  近24小时成交量: "24h volyymi",
  "提供数百种币币和合约交易对，以满足多样化的交易需求。 平台在200个国家和地区中有超过2千万用户，是全球领先的数字资产服务平台。":
    "Tarjoaa satoja spot- ja futuuripareja. Yli 20 miljoonaa käyttäjää 200+ maassa. Maailman johtava digitaalisten varojen palvelualusta.",
  用户国家分布: "Käyttäjät maittain",
  用户数: "Käyttäjien määrä",
  交易对: "Kaupankäyntiparit",
  服务支持: "Tuki",
  "随时随地，多平台终端交易": "Käy kauppaa missä tahansa monialustatuella",
  "多终端完美兼容，随时满足各种场景的交易需求。":
    "Yhteensopiva useiden laitteiden kanssa kaikkiin kaupankäyntitarpeisiin.",
  随时查看实时行情: "Katso reaaliaikaisia hintoja missä tahansa",
  "轻松买卖BTC，ETH，DOGE和其他数字资产":
    "Osta ja myy helposti BTC:tä, ETH:ta, DOGE:a ja muita digitaalisia varoja",
  获取您关注的加密货币价格变化预警:
    "Vastaanota hintahälytyksiä seuraamillesi kryptovaluutoille",
  "查看比特币现货、期货、期权价格":
    "Katso Bitcoinin spot-, futures- ja optiohintoja",
  比较各交易所加密货币价格: "Vertaa kryptovaluuttojen hintoja eri pörsseissä",
  开启您的数字货币之旅: "Aloita matkasi digitaalisten varojen parissa",
  快捷购买数字货币: "Osta kryptovaluuttoja nopeasti",
  "使用多种支付方式交易数字货币，安全快捷":
    "Käy kauppaa turvallisesti ja nopeasti useilla maksutavoilla",
  最优的交易费率: "Parhaat transaktiomaksut",
  "优惠的交易费率，富有竞争力的VIP权益，享受最优品质的服务":
    "Edulliset hinnat, kilpailukykyiset VIP-edut ja huippulaadukas palvelu.",
  可信赖的安全保障: "Luotettava turvallisuus",
  "我们复杂的安全措施和SAFU基金保护您的数字资产免受所有风险。":
    "Kehittyneet turvatoimet ja SAFU-rahasto suojaavat varojasi riskeiltä.",
  交易: "Kaupankäynti",
  币币市场: "Spot-markkinat",
  "24H成交量": "24h volyymi",
  交易所: "Pörssi",
  "24H最高": "24h korkein",
  "24H最低": "24h alin",
  永续合约: "Ikuiset futuurit",
  日涨跌: "Päivittäinen muutos",
  交易深度: "Toimeksiantosyvyys",
  "资产(合约)": "Varat (Futuurit)",
  历史仓位: "Positiohistoria",
  兑换记录: "Vaihtohistoria",
  类型: "Tyyppi",
  充值记录: "Talletushistoria",
  划转记录: "Siirtohistoria",
  类别: "Luokka",
  历史账单: "Laskuhistoria",
  在线充值: "Verkkotalletus",
  安全设置: "Turva-asetukset",
  用于账户登录使用: "Käytetään tilille kirjautumiseen",
  用户提现时安全验证使用:
    "Käytetään turvallisuuden varmistamiseen nostoja tehtäessä",
  验证: "Vahvista",
  万: "miljoona",
  随时随地开启交易: "Aloita kaupankäynti missä tahansa",
  "*货币交易所的所有功能尽在你的手中。":
    "Kaikki * kryptopörssin toiminnot kädessäsi.",
  "下载*货币交易所APP。": "Lataa * kryptopörssin sovellus.",
  下载自: "Lataa kohteesta",
  内测版: "Beta-versio",
  下载: "Lataa",
  扫码下载: "Skannaa ladataksesi",
  设置您的资产密码: "Aseta varojen salasanasi",
  法币: "Fiat",
  我要买: "Haluan ostaa",
  我要卖: "Haluan myydä",
  请输入金额: "Syötä summa",
  汇率: "Vaihtokurssi",
  获得: "Saat",
  支付通道: "Maksukanava",
  收款通道: "Vastaanottokanava",
  "出售过程需要务必确认好您的收款方式为本人。":
    "Varmista myydessäsi, että vastaanottokanava on omissa nimissäsi.",
  当前法币暂不支持交易对可尝试前往提现:
    "Tätä fiat-paria ei tueta tällä hetkellä. Yritä nostoa.",
  前往提现: "Siirry nostoon",
  该法币暂无通道: "Tälle fiat-valuutalle ei ole saatavilla kanavaa",
  "正在出售中，请耐心等待": "Myynti on käynnissä, odota",
  请选择支付通道: "Valitse maksukanava",
  请选择方式: "Valitse tapa",
  法币历史: "Fiat-historia",
  买币: "Osta kryptoja",
  卖币: "Myy kryptoja",
  失败: "Epäonnistui",
  已完成: "Valmis",
  未付款: "Maksamaton",
  待审核: "Odottaa",
  打款中: "Maksu käynnissä",
  订单详情: "Tilaustiedot",
  联系客服: "Ota yhteyttä asiakaspalveluun",
  到账金额: "Vastaanotettu summa",
  通道: "Kanava",
  收款人: "Vastaanottaja",
  收款账户: "Vastaanottajan tili",
  "订单出售失败，请查下方失败原因":
    "Tilauksen myynti epäonnistui. Katso syy alta.",
  失败原因: "Epäonnistumisen syy",
  您还未进行付款: "Et ole vielä maksanut",
  您已成功购买: "Osto onnistui",
  已取消订单: "Tilaus peruutettu",
  "订单正在审核中，请耐心等待": "Tilausta käsitellään. Odota.",
  您已成功出售: "Myynti onnistui",
  "订单正在打款中，请耐心等待": "Maksu on käynnissä. Odota.",
  "支付过程需要您前往其他的平台进行支付订单，请注意信息安全。":
    "Maksua varten sinun on siirryttävä toiselle alustalle. Huomioi tietoturvasi.",
  当前法币暂不支持交易对可尝试前往充值:
    "Tätä fiat-paria ei tueta tällä hetkellä. Yritä talletusta.",
  前往充值: "Siirry talletukseen",
  购买: "Osta",
  订单号: "Tilausnumero",
  单价: "Yksikköhinta",
  到账数量: "Vastaanotettu määrä",
  "当前存在未付的订单，是否继续发起新的支付订单？":
    "On maksamaton tilaus. Haluatko aloittaa uuden maksutilauksen?",
  继续支付: "Jatka maksua",
  重新下单: "Tee uusi tilaus",
  是否确定出售: "Oletko varma, että haluat myydä?",
  "确定出售后，平台将分配给买家，请耐心等待平台的撮合。":
    "Vahvistuksen jälkeen alusta osoittaa ostajan. Odota täsmäytystä.",
  出售: "Myy",
  收款方式: "Vastaanottotapa",
  订单已生成: "Tilaus luotu",
  取消订单: "Peruuta tilaus",
  请在: "Ole hyvä ja",
  内完成付款: "sisällä suorita maksu",
  "离开平台，登录您指定的支付，转账到卖家的以下账户，并务必在付款中备注：":
    "Poistu alustalta, kirjaudu sisään valitsemaasi maksutapaan ja siirrä summa myyjän seuraavalle tilille. Muista aina mainita viite:",
  "若付款时未进行备注，卖家将无法确认收款，造成资产损失无法找回。":
    "Ilman viitettä myyjä ei voi vahvistaa maksua, mikä voi johtaa varojen menetykseen.",
  "未在规定的时间内付款，订单都将被取消。":
    "Jos et maksa määräajassa, tilaus peruutetaan.",
  姓名: "Nimi",
  收款姓名: "Vastaanottajan nimi",
  开户支行: "Pankkikonttori",
  银行卡号: "Pankkikortin numero",
  "付款后，返回本平台": "Maksun jälkeen palaa tälle alustalle",
  "请务必点击下方“我已完成付款，通知卖家”按钮":
    "Napsauta alla olevaa 'Olen suorittanut maksun, ilmoita myyjälle' -painiketta",
  未点击卖家不会放款:
    "Myyjä vapauttaa kryptot vasta, kun olet napsauttanut painiketta",
  交易条款: "Kaupankäyntiehdot",
  "购买资金来源，必须合法安全的资金，方可交易":
    "Ostoon käytettävien varojen on oltava laillisia ja turvallisia",
  "不允许诈骗、传销、赌博或者其他非法资金交易":
    "Petokset, pyramidipelit, uhkapeli tai muut laittomat varat eivät ole sallittuja",
  "交易完成后，出现资金风险，被冻结或者涉嫌欺诈、传销、赌博的资金，我方将不在向买方放U，并给予退款":
    "Jos varat jäädytetään tai ne ovat epäilyttäviä transaktion jälkeen, emme vapauta USDT:ta ja teemme hyvityksen",
  "已付款，通知卖家": "Maksettu, ilmoita myyjälle",
  "买方当日累计取消*笔订单，将会取消当日购买功能。确定取消该订单吗？":
    "Jos peruutat yhteensä * tilausta tänään, ostooikeutesi peruuntuu tältä päivältä. Peruutetaanko tämä tilaus?",
  添加收款方式: "Lisää vastaanottotapa",
  是否删除此收款方式: "Poistetaanko tämä vastaanottotapa?",
  删除: "Poista",
  请选择法币: "Valitse fiat-valuutta",
  机构名称: "Laitoksen nimi",
  请选择机构: "Valitse laitos",
  "当您出售数字货币时，您选择的收款方式将向买方展示，请确认填写无误。":
    "Valitsemasi vastaanottotapa näytetään ostajille, kun myyt kryptoja. Varmista, että tiedot ovat oikein.",
  请选择银行: "Valitse pankki",
  请输入姓名: "Syötä nimi",
  账号: "Tilinumero",
  请输入账号: "Syötä tilinumero",
  收款码: "Vastaanottokoodi",
  "银行账号/卡号": "Pankkitili/Korttinumero",
  "请输入银行账号/卡号": "Syötä pankkitili/korttinumero",
  "开户支行（选填）": "Pankkikonttori (valinnainen)",
  请输入开户支行: "Syötä pankkikonttori",
  "加入*官方频道": "Liity * viralliselle kanavalle",
  关于: "Tietoja",
  条款: "Ehdot",
  成功: "Onnistui",
  等待: "Odota",
  作废: "Mitätön",
  确认付款: "Vahvista maksu",
  "是否已完成付款？若确认付款后，商家将会在*分内进行确认是否收到付款。":
    "Maksu suoritettu? Vahvistuksen jälkeen myyjä vahvistaa maksun saapumisen * minuutin kuluessa.",
  最大金额: "Maksimisumma",
  最小金额: "Minimisumma",
  付款: "Maksa",
  法币充值: "Fiat-talletus",
  法币提现: "Fiat-nosto",
  待支付: "Odottaa maksua",
  已支付: "Maksettu",
  商户名: "Myyjän nimi",
  当前没有添加支付方式: "Maksutapaa ei ole lisätty",
  添加后再出售: "Lisää yksi ennen myyntiä",
  新人大礼包: "Tervetuliaispaketti",
  注册即可领取: "Vastaanota rekisteröitymisen jälkeen",
  立即领取: "Vastaanota nyt",
  不再提示: "Älä näytä uudelleen",
  "该奖励需在APP中领取，请下载APP":
    "Tämä palkinto voidaan vastaanottaa vain sovelluksessa. Lataa sovellus.",
  去交易: "Siirry kaupankäyntiin",
  期权交易: "Optiokauppa",
  交易额: "Kaupankäynnin määrä",
  可用额度: "Käytettävissä oleva raja",
  交易周期: "Kaupankäyntijakso",
  看涨: "Nouseva (Call)",
  看跌: "Laskeva (Put)",
  看空: "Lyhyt",
  当前持有: "Nykyinen positio",
  胜率: "Voittoprosentti",
  "盈利/亏损数": "Voitto/tappio -transaktioiden määrä",
  累计实现盈亏: "Toteutunut kokonaisvoitto/tappio",
  秒: "sekuntia",
  分: "minuuttia",
  小时: "tuntia",
  周: "viikko",
  下单时间: "Tilausaika",
  剩余时间: "Jäljellä oleva aika",
  买入价: "Ostohinta",
  结算价: "Selvityshinta",
  实现盈利: "Toteutunut voitto",
  结算时间: "Selvitysaika",
  期权: "Optio",
  新手教程: "Aloittelijan opas",
  我的订单: "Tilaukseni",
  赔率: "Kerroin",
  全部订单: "Kaikki tilaukset",
  持有订单: "Avoimet tilaukset",
  历史订单: "Tilaushistoria",
  输入交易额度: "Syötä kaupankäyntimäärä",
  选择交易周期: "Valitse kaupankäyntijakso",
  去注册: "Rekisteröidy",
  冻结: "Jäädytä",
  期权支出: "Option kulu",
  期权收入: "Option tuotto",
  用户提现: "Käyttäjän nosto",
  "是否购买？": "Ostetaanko tämä optio?",
  购买成功: "Osto onnistui",
  请签名: "Ole hyvä ja allekirjoita",
  提交签名: "Lähetä allekirjoitus",
  清空签名: "Tyhjennä allekirjoitus",
  签名审核中: "Allekirjoitus käsittelyssä",
  已提交: "Lähetetty",
  扫一扫下载APP: "Skannaa ladataksesi sovelluksen",
  新手领取大礼包: "Uuden käyttäjän tervetuliaispaketti",
  注册实名即送彩金:
    "Rekisteröidy ja vahvista henkilöllisyytesi saadaksesi bonuksen",
  交易总额: "Kaupankäynnin kokonaisvolyymi",
  资产不足: "Varat eivät riitä",
  "Win账户的资产不足，可从资金账户划转至此账户":
    "WIN-tilin varat eivät riitä. Voit siirtää varoja päätililtäsi.",
  Win: "WIN",
  比赛: "Kilpailu",
  未开始: "Ei alkanut",
  赛程: "Ohjelma",
  赛果: "Tulos",
  已结束: "Päättynyt",
  让球: "Tasoitus",
  进球数: "Maalit",
  大: "Yli",
  小: "Alle",
  胜负平: "1X2 (Voitto/Tasapeli/Tappio)",
  和局: "Tasapeli",
  投注: "Panos",
  下注金额: "Panoksen määrä",
  下注: "Aseta panos",
  阵容: "Kokoonpano",
  分析: "Analyysi",
  输入下注金额: "Syötä panoksen määrä",
  下注成功: "Panos asetettu",
  投注记录: "Panostushistoria",
  未结算: "Ei selvitetty",
  已结算: "Selvitetty",
  流水: "Volyymi",
  输赢: "Voitto/Tappio",
  赛时: "Ottelun aika",
  下注时间: "Panostusaika",
  足彩竞猜: "Jalkapallovedonlyönti",
  查看详情: "Katso tiedot",
  输: "Tappio",
  赢: "Voitto",
  主: "Koti",
  客: "Vieras",
  主胜: "Kotivoitto",
  客胜: "Vierasvoitto",
  平: "Tasapeli",
  已延期: "Siirretty",
  账号异常: "Tilin poikkeama",
  全场独赢: "Koko ottelu 1X2",
  全场让球: "Koko ottelu Tasoitus",
  全场大小: "Koko ottelu Yli/Alle",
  总进球: "Maalit yhteensä",
  拍摄照片要求: "Valokuvausvaatimukset",
  标准拍摄: "Normaali valokuva",
  边框缺失: "Reuna puuttuu",
  照片模糊: "Epäselvä valokuva",
  闪光强烈: "Liian voimakas salama",
  上传手持证件照: "Lataa kuva asiakirjasta kädessä",
  上传证件照: "Lataa kuva asiakirjasta",
  换一张: "Uusi kuva",
  出生日期: "Syntymäaika",
  请选择出生日期: "Valitse syntymäaika",
  "输入下方正确的图形验证后，获取邮箱验证码进行注册":
    "Syötä alla oleva vahvistuskoodi saadaksesi sähköpostikoodin rekisteröitymistä varten.",
  "您还剩余*次认证次数，超出次数将无法继续认证":
    "Sinulla on vielä * vahvistusyritystä jäljellä. Tämän rajan jälkeen et voi vahvistaa itseäsi.",
  上半场: "1. puoliaika",
  下半场: "2. puoliaika",
  独赢: "1X2",
  上半场独赢: "1. puoliaika 1X2",
  下半场独赢: "2. puoliaika 1X2",
  上半场让球: "1. puoliaika Tasoitus",
  下半场让球: "2. puoliaika Tasoitus",
  上半场大小球: "1. puoliaika Yli/Alle",
  下半场大小球: "2. puoliaika Yli/Alle",
  波胆: "Tarkka lopputulos",
  上半场波胆: "1. puoliaika Tarkka lopputulos",
  下半场波胆: "2. puoliaika Tarkka lopputulos",
  单双: "Pariton/Tasainen",
  单: "Pariton",
  双: "Tasainen",
  上半场单双: "1. puoliaika Pariton/Tasainen",
  下半场单双: "2. puoliaika Pariton/Tasainen",
  上半场总进球: "1. puoliaika Maalit yhteensä",
  下半场总进球: "2. puoliaika Maalit yhteensä",
  中场: "Puoliaika",
  "注意：手持证件照请按照此示例图在白纸上书写文字并与证件一起拍摄":
    "Huomautus: Ota kuvaa varten asiakirja kädessä, kirjoita teksti valkoiselle paperille ja valokuvaa se yhdessä asiakirjasi kanssa, kuten esimerkissä.",
  "近期发现大量作弊账户，对一批违规账户进行了惩罚。如果有误判为违规账户，请联系在线客服。":
    "Monet vilpilliset tilit on äskettäin rangaistu. Ota yhteyttä asiakaspalveluun, jos uskot tilisi tulleen epäoikeudenmukaisesti rangaistuksi.",
  最小下注金额: "Minimipanos",
  参与活动最小下注金额: "Minimipanos aktiviteettiin osallistumiseksi",
  记住密码: "Muista salasana",
  比分: "Tulos",
  "您还未登录，请先登录": "Et ole kirjautunut sisään. Kirjaudu ensin sisään.",
  立即登录: "Kirjaudu sisään nyt",
  下注限额: "Panosraja",
  可赢金额: "Mahdollinen voittosumma",
  闪兑详情: "Pikavaihdon tiedot",
  大小球: "Yli/Alle",
  "由于汇率原因，下注金额和实际下注金额会有误差，请以订单为准。":
    "Valuuttakurssivaihteluiden vuoksi lopullinen panosmäärä voi poiketa. Tilaus on sitova.",
  开赛时间: "Alkamisaika",
  足球收入: "Jalkapallotulot",
  足球支出: "Jalkapallomenot",
  活动详情: "Aktiviteetin tiedot",
  为世界杯喝彩: "Tue maailmanmestaruuskilpailuja",
  我的竞猜: "Veikkaukseni",
  "竞猜比赛、有机会瓜分*USDT": "Veikkaa otteluita ja voita osuus * USDT:stä",
  "瓜分*USDT": "Jaa * USDT",
  距离活动结束还有: "Aktiviteetin päättymiseen:",
  我的门票: "Lippuni",
  竞猜结束时间: "Veikkauksen päättymisaika",
  猜比分: "Veikkaa lopputulosta",
  "福利派送中，完成任务即可获取门票":
    "Bonuksia jaetaan. Suorita tehtäviä ansaitaksesi lippuja.",
  "完成如下任务，可获对应数量门票的参与竞赛":
    "Suorita seuraavat tehtävät saadaksesi vastaavan määrän lippuja osallistuaksesi kilpailuun.",
  时: "tunti",
  活动: "Aktiviteetti",
  竞猜记录: "Veikkaushistoria",
  结果: "Tulos",
  任务: "Tehtävä",
  去邀请: "Kutsu",
  "每场比赛的比分竞猜，参与竞猜可瓜分$*美金的奖励。":
    "Veikkaa jokaisen ottelun lopputulos ja voita osuus $*:sta.",
  "参与竞猜需要门票，门票可按照平台的任务进行获得。":
    "Veikkaaminen vaatii lipun. Lippuja voi ansaita suorittamalla alustan tehtäviä.",
  "竞猜成功后，把竞猜结果的截图发送给客服，客服会把奖金划入您的资金账户，你可以立即提取。":
    "Onnistuneen veikkauksen jälkeen lähetä kuvakaappaus asiakaspalveluun. He hyvittävät bonuksen tilillesi, jonka voit nostaa välittömästi.",
  "禁止任何作弊行为、如果发现作弊行为，奖励无效。":
    "Huijaaminen on kiellettyä. Jos se havaitaan, palkinto mitätöidään.",
  "完成任务后，点击咨询客服获得门票。":
    "Tehtävien suorittamisen jälkeen napsauta 'Ota yhteyttä asiakaspalveluun' saadaksesi lippuja.",
  继续猜: "Jatka veikkaamista",
  总单数: "Vetojen kokonaismäärä",
  赛事筛选: "Suodata tapahtuman mukaan",
  球队筛选: "Suodata joukkueen mukaan",
  总金额: "Kokonaissumma",
  总流水: "Kokonaisvolyymi",
  派奖金额: "Jaetun bonuksen määrä",
  下注单数: "Vetojen määrä",
  利润: "Voitto",
  更多福利: "Lisää bonuksia",
  我的奖金: "Bonukseni",
  未认证: "Vahvistamaton",
  总量: "Yhteensä",
  或: "tai",
  模拟交易: "Demokauppa",
  体验账户不可操作: "Ei käytettävissä demotilillä",
  世界杯比分竞猜: "MM-kisojen lopputulosten veikkaus",
  "领*USDT起": "Vastaanota alkaen * USDT",
  消息: "Viestit",
  滚球: "Live-vedonlyönti",
  是: "Kyllä",
  不是: "Ei",
  当前余额: "Nykyinen saldo",
  KOL招募: "KOL-rekrytointi",
  本月净输赢: "Nettovoitto/tappio tässä kuussa",
  本月佣金: "Provisio tässä kuussa",
  佣金比例: "Provision osuus",
  活跃人数: "Aktiiviset käyttäjät",
  新增下级: "Uudet alarivit",
  登录人数: "Kirjautuneet käyttäjät",
  首存人数: "Ensimmäisen talletuksen tehneet käyttäjät",
  数据分析: "Data-analyysi",
  人数: "Henkilömäärä",
  新注册存款金额: "Uusien rekisteröitymisten talletussumma",
  老用户存款金额: "Nykyisten käyttäjien talletussumma",
  首存金额: "Ensimmäisen talletuksen summa",
  快捷入口: "Pikakäyttö",
  成员管理: "Jäsenhallinta",
  财务报表: "Tilinpäätösraportit",
  分红报表: "Osinkoraportti",
  订单记录: "Tilaushistoria",
  VIP专享: "VIP-yksinoikeus",
  推广工具: "Markkinointityökalut",
  计算规则: "Laskentasäännöt",
  账变明细: "Tapahtuman yksityiskohdat",
  成员: "Jäsenet",
  下级概览: "Yleiskatsaus alariveistä",
  下级成员总计: "Alarivit yhteensä",
  本月新增: "Uudet tässä kuussa",
  本月活跃会员: "Aktiiviset jäsenet tässä kuussa",
  今日活跃会员: "Aktiiviset jäsenet tänään",
  本月有效活跃: "Tehokkaasti aktiiviset tässä kuussa",
  活跃成员占比: "Aktiivisten jäsenten osuus",
  本月活跃: "Aktiiviset tässä kuussa",
  今日活跃: "Aktiiviset tänään",
  下级成员: "Alarivit",
  会员账号: "Jäsentili",
  统计时间: "Tilastointiaika",
  筛选: "Suodata",
  存款: "Talletus",
  取款: "Nosto",
  总输赢: "Kokonaisvoitto/tappio",
  是否有效用户: "Aktiivinen käyttäjä?",
  最近登录时间: "Viimeisin kirjautuminen",
  否: "Ei",
  开始时间: "Alkamisaika",
  结束时间: "Päättymisaika",
  提取: "Nosta",
  总盈亏: "Kokonaistulos",
  净盈亏: "Nettotulos",
  分红: "Osinko",
  概览: "Yleiskatsaus",
  月度详细数据: "Kuukausittaiset yksityiskohtaiset tiedot",
  未发放: "Ei jaettu",
  活跃用户: "Aktiiviset käyttäjät",
  有效新增会员: "Tehokkaat uudet jäsenet",
  冲正后净输赢: "Nettovoitto/tappio korjauksen jälkeen",
  上月结余: "Edellisen kuukauden saldo",
  净输赢: "Nettovoitto/tappio",
  "系统每日新加坡时间1:00更新一次报表":
    "Raportit päivitetään päivittäin klo 01:00 Singaporen aikaa.",
  "报表中数据、总输赢、净输赢中正数表示代理方盈利、负数表示代理方亏损":
    "Raporteissa positiiviset luvut tarkoittavat kumppanin voittoa, negatiiviset luvut kumppanin tappiota.",
  "佣金数据每天进行更新，仅供参考，并不做实际佣金派发标准":
    "Provisiotiedot päivitetään päivittäin, ne ovat suuntaa-antavia eivätkä muodosta lopullista maksuperustetta.",
  选择时间: "Valitse aika",
  足球: "Jalkapallo",
  投注金额: "Panoksen määrä",
  有效订单: "Kelvolliset tilaukset",
  下级账户: "Alarivin tili",
  待成交: "Odottaa",
  下单金额: "Tilauksen määrä",
  订单内容: "Tilauksen sisältö",
  秒数: "Sekunnit",
  联赛: "Liiga",
  队伍: "Joukkue",
  比赛时间: "Ottelun aika",
  玩法: "Vetotyyppi",
  等级规则表: "Tasosääntötaulukko",
  等级: "Taso",
  活跃会员: "Aktiiviset jäsenet",
  最新活跃: "Viimeisin aktiviteetti",
  额外佣金: "Lisäprovisio",
  "每月按照对应等级的增长标准与奖励制度执行，只可享受一个等级奖励。":
    "Kuukausittain kasvustandardien perusteella. Voit hyötyä vain yhdestä tasosta.",
  渠道生成: "Luo kanava",
  创建: "Luo",
  渠道名称: "Kanavan nimi",
  注册人数: "Rekisteröitymisten määrä",
  浏览人数: "Katselukertojen määrä",
  构建状态: "Rakennuksen tila",
  禁用: "Poista käytöstä",
  启用: "Ota käyttöön",
  查看: "Katso",
  创建渠道: "Luo kanava",
  创建成功: "Luominen onnistui",
  操作成功: "Toiminto onnistui",
  渠道详情: "Kanavan tiedot",
  邀请码: "Kutsukoodi",
  访问人数: "Kävijöiden määrä",
  渠道地址: "Kanavan osoite",
  我的福利: "Bonukseni",
  充值福利: "Talletusbonus",
  当前流水: "Nykyinen volyymi",
  如何参与: "Kuinka osallistua",
  币种充值: "Kryptovaluuttatalletus",
  充值福利中领取福利: "Vastaanota bonus talletusbonuksesta",
  "规则：充值福利自愿领取，有效期为充值后的24小时内，过期无效，领取后将暂时锁定提现功能，当流水达到后即可解锁提现。":
    "Sääntö: Talletusbonus on vapaaehtoinen, voimassa 24 tuntia talletuksen jälkeen. Vastaanoton jälkeen nosto estetään väliaikaisesti, kunnes volyymivaatimus on saavutettu.",
  失效日期: "Voimassaolon päättymispäivä",
  "暂无福利领取，充值后领取":
    "Bonusta ei ole saatavilla. Vastaanota talletuksen jälkeen.",
  参与: "Osallistu",
  充值赠送: "Talletusbonus",
  "领取*%的赠送": "Vastaanota *% bonus",
  去领取: "Vastaanota",
  VIP奖励: "VIP-palkinto",
  "当前可领取*USDT，是否确认领取":
    "* USDT saatavilla vastaanotettavaksi. Vahvistetaanko?",
  "领取后将临时锁定提现功能，当您的流水到达*USDT后即可解除锁定":
    "Vastaanoton jälkeen nosto estetään väliaikaisesti, kunnes * USDT:n volyymi on saavutettu.",
  充值送大礼: "Talletuslahja",
  "存入越多，送越多！": "Mitä enemmän talletat, sitä suurempi lahja!",
  无效: "MitÃ¤tÃ¶n",
  有效: "Kelvollinen",
  总存金额: "Talletettu summa yhteensä",
  提示: "Huomautus",
  "总输赢，净输赢中正数表示平台盈利，负数表示亏损，每天数据只做参考，并不做实际佣金派发标准。":
    "Positiiviset luvut kokonais- ja nettovoitossa/tappiossa tarkoittavat alustan voittoa. Päivittäiset tiedot ovat suuntaa-antavia.",
  "净盈亏：总盈亏-用户返水":
    "Nettotulos: Kokonaistulos - Käyttäjän käteispalautus",
  盈利方: "Voittopuoli",
  代理: "Agentti",
  客户: "Asiakas",
  平局: "Tasapeli",
  平台: "Alusta",
  "已提交审核，请耐心等待": "Lähetetty vahvistettavaksi. Odota.",
  充值日期: "Talletuspäivä",
  平台本月总输赢: "Alustan kokonaisvoitto/tappio tässä kuussa",
  KOL招募合作: "KOL-rekrytointiyhteistyö",
  "平台现在开放【KOL招募活动】，只要您有社群媒体号，就可以和平台享受分红一次性推广客户，就可以享受终生收益。":
    "Alusta avaa KOL-rekrytoinnin. Sosiaalisen median tilillä voit nauttia osingoista ja elinikäisistä tuloista kertaluonteisella asiakashankinnalla.",
  级别: "Taso",
  平台利润返佣: "Alustan voittoprovisio",
  佣金案例: "Provisioesimerkki",
  交易项目: "Kaupankäyntituotteet",
  "期权交易、合约交易、足球游戏": "Optiokauppa, futuurikauppa, jalkapallopelit",
  报名方式: "Ilmoittautumistapa",
  点击KOL招募报名: "Napsauta ilmoittautuaksesi KOL-rekrytointiin",
  "欢迎加入我们的团队，平台全面扶持您建立属于自己的用户体系，最高可得*的佣金，我们期待您加入。":
    "Tervetuloa tiimiimme. Tuemme sinua oman käyttäjäjärjestelmäsi rakentamisessa. Ansaitse jopa *% provisiota. Odotamme innolla osallistumistasi.",
  输入联系方式: "Syötä yhteystiedot",
  最低活跃人数: "Aktiivisten käyttäjien vähimmäismäärä",
  "如：本月活跃人数≥*并且本月平台总输赢≥*USDT，您属于等级*，即可得到*%的佣金。":
    "Esimerkiksi: Jos aktiiviset käyttäjät tässä kuussa ≥ * ja alustan kokonaisvoitto/tappio ≥ * USDT, kuulut tasoon * ja saat *% provisiota.",
  比分竞猜: "Lopputuloksen veikkaus",
  豪礼相赠: "Suuri lahja",
  足球活动: "Jalkapalloaktiviteetti",
  圣诞节活动: "Jouluaktiviteetti",
  "您参加了活动，临时锁定提现功能，还需*USDT流水就可以解除锁定。":
    "Olet osallistunut aktiviteettiin. Nosto on väliaikaisesti estetty. Tarvitset vielä * USDT volyymin avataksesi lukituksen.",
  剩余流水: "Jäljellä oleva volyymi",
  助力足球: "Tue jalkapalloa",
  佣金累计: "Provisio yhteensä",
  有效投注: "Kelvolliset vedot",
  今日: "Tänään",
  今日返水: "Käteispalautus tänään",
  VIP返水: "VIP-käteispalautus",
  返水记录: "Käteispalautushistoria",
  成员信息: "Jäsentiedot",
  基本信息: "Perustiedot",
  钱包余额: "Lompakon saldo",
  投注信息: "Vedonlyöntitiedot",
  返水: "Käteispalautus",
  总下注: "Panokset yhteensä",
  今日输赢: "Voitto/tappio tänään",
  下注动态: "Vedonlyöntiaktiivisuus",
  返水奖励: "Käteispalautuspalkinto",
  分红金额: "Osingon määrä",
  返水支出: "Käteispalautuksen kulu",
  总返水: "Käteispalautus yhteensä",
  流水总额: "Kokonaisvolyymi",
  返水总额: "Käteispalautus yhteensä",
  返水详情: "Käteispalautuksen tiedot",
  日流水: "Päivittäinen volyymi",
  "平台根据你下级每日流水进行额外返水奖励,奖励每日新加坡时间00：00进行派发至赏金账户":
    "Alusta antaa lisäkäteispalautusta alariviesi päivittäisen volyymin perusteella. Maksu päivittäin klo 00:00 Singaporen aikaa palkintotilille.",
  "申请成功，等待审核": "Hakemus onnistui, odottaa vahvistusta",
  "我出本金，盈利共分享": "Annan pääoman, voitto jaetaan",
  最高分红: "Maksimiosinko",
  投资大师比赛: "Mestarisijoittajan kilpailu",
  "我出本金，你盈利": "Annan pääoman, sinä ansaitset",
  共分享: "Jaa yhdessä",
  最高分红可得: "Suurin mahdollinen osinko",
  "新用户专属福利来袭，免费赠送$*，领取后即可投资平台任何项目，盈利后立即可提取。":
    "Yksinoikeudellinen tervetuliaisbonus: $* ilmaiseksi. Vastaanoton jälkeen voit sijoittaa mihin tahansa projektiin. Voitto on heti nostettavissa.",
  报名领取: "Ilmoittaudu ja vastaanota",
  审核驳回: "Vahvistus hylätty",
  驳回原因: "Hylkäämisen syy",
  活动运行周期: "Aktiviteetin kesto",
  "申请成功后起至*天内完成超额收益。":
    "Saavuta ylituotto * päivän kuluessa hyväksynnästä.",
  分红比: "Osinkosuhde",
  "*日获得盈利后，可获得*%的收益额。":
    "Kun olet saavuttanut voittoa päivänä *, saat *% tuottosummasta.",
  参与条件: "Osallistumisehdot",
  "俄罗斯、土耳其地区的用户，且未参与。":
    "Käyttäjät Venäjältä tai Turkista, jotka eivät ole vielä osallistuneet.",
  计算项目: "Lasketut tuotteet",
  "合约、体育、期权": "Futuurit, Urheilu, Optiot",
  我的投资: "Sijoitukseni",
  参与天数: "Osallistumispäivät",
  累计下注: "Panokset yhteensä",
  累计盈亏: "Kokonaisvoitto/tappio",
  预计可分红: "Odotettu osinko",
  常见问题: "Usein kysytyt kysymykset (UKK)",
  什么是平台出资: "Mitä on alustan rahoitus?",
  "平台根据部分国家的用户，免费提供资金让用户去投项目。":
    "Alusta antaa ilmaisia varoja tiettyjen maiden käyttäjille sijoittamista varten projekteihin.",
  怎么获取平台出资的福利: "Miten saan alustan rahoitusbonuksen?",
  "您是指定国家的用户即可，点击上方报名按钮，当平台审核完成后将会把*USDT转入当前账户下的赏金账户，您可划转至其他账户下进行投资。":
    "Jos olet yhdestä määrätystä maasta, napsauta ilmoittautumispainiketta. Hyväksynnän jälkeen * USDT siirretään palkintotilillesi, jonka voit siirtää sijoittaaksesi.",
  什么是分红: "Mitä on osinko?",
  "分红指在规定时间内，收益额到达100%后，可分得超额收益的50%。例如：领取100USDT资金，收益额度是120%。":
    "Osinko: Jos tuotto saavuttaa 100% määräajassa, saat 50% ylituotosta. Esimerkki: Vastaanota 100 USDT, saavuta 120% tuotto, niin 20% on ylituottoa.",
  "如何取得分红？": "Miten saan osingon?",
  "活动周期每*天1次，活动结束后进行核算，满足活动要求后分红派发至赏金账户。若你未达到活动要求，系统将自动清除你的收益额和平台的出资。":
    "Aktiviteettisykli on joka * päivä. Päätyttyä suoritetaan selvitys. Jos täytät vaatimukset, osinko lähetetään palkintotilille. Jos et täytä, tuottosi ja alustan rahoitus poistetaan.",
  "参与的账号需进行KYC认证，每个账户仅限一份福利。":
    "Osallistuvien tilien on oltava KYC-vahvistettuja. Vain yksi bonus per tili.",
  "参与账号的KYC需要指定的国家方可参与，其他地区无权限参与，请核对活动国家与您的国家是否一致。":
    "KYC osallistumista varten on voimassa vain määrätyissä maissa. Tarkista, vastaako maasi aktiviteettimaata.",
  "参与活动成功后，账户将临时锁定您的提现功能，当完成活动后即可解除您的提现功能。":
    "Onnistuneen osallistumisen jälkeen nosto estetään väliaikaisesti, kunnes aktiviteetti on suoritettu loppuun.",
  "请遵守平台活动规则，若发现作弊、利用系统漏洞进行获利，平台将会长期冻结您的账户下所有资金。":
    "Noudata aktiviteetin sääntöjä. Jos huijaat tai käytät väärin järjestelmävirheitä, kaikki tilisi varat jäädytetään pysyvästi.",
  平台出资: "Alustan rahoitus",
  平台出资收回: "Alustan rahoitus peruttu",
  投资大师奖励: "Mestarisijoittajan palkinto",
  请下载APP添加收款方式: "Lataa sovellus lisätäksesi vastaanottotavan",
  请下载APP进行身份验证:
    "Lataa sovellus suorittaaksesi henkilöllisyyden vahvistuksen",
  请下载APP参与: "Lataa sovellus osallistuaksesi",
  技术指标: "Tekniset indikaattorit",
  主图: "Pääkaavio",
  副图: "Toissijainen kaavio",
  新注册人数: "Uudet rekisteröitymät",
  老用户存款人数: "Nykyiset käyttäjät, jotka tallettavat",
  存款人数: "Talletusten määrä",
  取款人数: "Nostojen määrä",
  投注人数: "Vetojen määrä",
  "除印度尼西亚、印度、孟加拉国，且未参与过的用户。":
    "Lukuun ottamatta käyttäjiä Indonesiasta, Intiasta, Bangladeshista, jotka eivät ole vielä osallistuneet.",
  市场动态: "Markkinadynamiikka",
  外汇合约: "Forex-futuurit",
  盈亏比: "Voitto/tappio-suhde",
  委托价: "Toimeksiannon hinta",
  可用余额: "Käytettävissä oleva saldo",
  持仓额: "Position arvo",
  强平价: "Likvidointihinta",
  修改: "Muokkaa",
  修改价位: "Muokkaa hintaa",
  外汇: "Forex",
  外汇账户: "Forex-tili",
  我的交易: "Omat kaupat",
  未设置: "Ei asetettu",
  超出最大可设数值: "Ylittää suurimman sallitun arvon",
  超出最小可设数值: "Alittaa pienimmän sallitun arvon",
  止盈超出最小可设数值: "Voitonotto alittaa pienimmän sallitun arvon",
  止损超出最大可设数值: "Tappionrajoitus ylittää suurimman sallitun arvon",
  止盈超出最大可设数值: "Voitonotto ylittää suurimman sallitun arvon",
  止损超出最小可设数值: "Tappionrajoitus alittaa pienimmän sallitun arvon",
  挖矿: "Louhinta",
  交易账户: "Kaupankäyntitili",
  买涨: "Osta (Pitkä)",
  买跌: "Myy (Lyhyt)",
  请输入正确的银行卡信息: "Syötä oikeat pankkikorttitiedot",
  联系在线客服: "Ota yhteyttä live-asiakaspalveluun",
  法币交易请联系在线客服:
    "Ota yhteyttä asiakaspalveluun fiat-kaupankäyntiä varten",
  提交订单: "Lähetä tilaus",
  "支付过程如有疑问,请联系在线客服":
    "Ota yhteyttä asiakaspalveluun, jos sinulla on kysyttävää maksuprosessista",
  彩金赠送: "Bonuksen myöntäminen",
  在线客服: "Live-chat",
  最少投资: "Minimisijoitus",
  "提交时间:": "Lähetysaika:",
  提现拒绝: "Nosto hylätty",
  认证拒绝: "Vahvistus hylätty",
  认证通过: "Vahvistus hyväksytty",
  请输入正确的交易额度: "Syötä kelvollinen kaupankäyntimäärä",
  最大下注金额: "Maksimipanos",
  手机号: "Matkapuhelinnumero",
  邮箱注册: "Rekisteröidy sähköpostilla",
  手机号注册: "Rekisteröidy matkapuhelinnumerolla",
  查询: "Hae",
  手机号登录: "Kirjaudu sisään matkapuhelinnumerolla",
  邮箱登录: "Kirjaudu sisään sähköpostilla",
  请输入数量: "Syötä määrä",
  可用数量: "Käytettävissä oleva määrä",
  钱包登录: "Kirjaudu sisään lompakolla",
  请输入正确的邀请码: "Syötä kelvollinen kutsukoodi",
  "请输入邀请码(必填)": "Syötä kutsukoodi (pakollinen)",
  输入正确的金额: "Syötä kelvollinen summa",
  法币充值: "Fiat-talletus",
  卢比充值: "Intian rupian talletus",
  请输入法币: "Syötä fiat-määrä",
  请输入IFSC: "Syötä IFSC-koodi",
  "银行编码(选填)": "Pankkikoodi (valinnainen)",
  请输入银行编码: "Syötä pankkikoodi",
  请输入大于8位数的密码: "Syötä salasana, jossa on yli 8 merkkiä",
  添加成功: "Lisätty",
  "60秒": "60 sekuntia",
  "180秒": "180 sekuntia",
  "300秒": "300 sekuntia",
  "2次密码不一致": "Salasanat eivät täsmää",
  输入提币数量: "Syötä nostomäärä",
  图片格式不正确: "Virheellinen kuvamuoto",
  图片大于20M: "Kuva on suurempi kuin 20 Mt",
  请设置委托价格: "Aseta toimeksiannon hinta",
  输入资金密码: "Syötä varojen salasana",
  验证码错误: "Virheellinen vahvistuskoodi",
  充值拒绝: "Talletus hylätty",
  请输入SSN: "Syötä SSN",
  结算完成: "Selvitys valmis",
  继续下单: "Jatka tilaamista",
  限价: "Limit-toimeksianto",
  买入价格: "Ostohinta",
  买入量: "Ostomäärä",
  卖出价格: "Myyntihinta",
  卖出量: "Myyntimäärä",
  买入: "Osta",
  卖出: "Myy",
  订单创建成功: "Tilaus luotu",
  币币买入支出: "Spot-oston kulu",
  币币买入支出退还: "Spot-oston kulun palautus",
  币币买入获得: "Spot-ostosta saatu",
  币币卖出支出: "Spot-myynnin kulu",
  币币卖出支出退还: "Spot-myynnin kulun palautus",
  币币卖出获得: "Spot-myynnistä saatu",
  币币交易手续费: "Spot-kaupan transaktiomaksu",
  请输入限价: "Syötä rajahinta",
  成交: "Toteutettu",
  等待成交: "Odottaa toteutusta",
  交易完成: "Kauppa valmis",
  被取消: "Peruttu",
  交易时间: "Kaupankäyntiaika",
  法币交易: "Fiat-kauppa",
  法币出售: "Fiat-myynti",

  两次密码不一致: "Salasanat eivät täsmää",
  再次输入账户密码: "Syötä tilin salasana uudelleen",

  美国: "Yhdysvallat",
  韩国: "Etelä-Korea",
  阿尔巴尼亚: "Albania",
  津巴布韦: "Zimbabwe",
  赞比亚: "Sambia",
  也门: "Jemen",
  美属维尔京群岛: "Yhdysvaltain Neitsytsaaret",
  英属处女群岛: "Brittiläiset Neitsytsaaret",
  越南: "Vietnam",
  委内瑞拉: "Venezuela",
  瓦努阿图: "Vanuatu",
  乌兹别克斯坦: "Uzbekistan",
  乌拉圭: "Uruguay",
  英国: "Yhdistynyt kuningaskunta",
  阿拉伯联合酋长国: "Yhdistyneet arabiemiirikunnat",
  乌克兰: "Ukraina",
  乌干达: "Uganda",
  特克斯和凯科斯群岛: "Turks- ja Caicossaaret",
  土库曼斯坦: "Turkmenistan",
  土耳其: "Turkki",
  突尼斯: "Tunisia",
  特立尼达和多巴哥: "Trinidad ja Tobago",
  汤加: "Tonga",
  多哥: "Togo",
  东帝汶: "Itä-Timor",
  泰国: "Thaimaa",
  坦桑尼亚: "Tansania",
  塔吉克斯坦: "Tadžikistan",
  中国台湾: "Taiwan",
  叙利亚: "Syyria",
  瑞士: "Sveitsi",
  瑞典: "Ruotsi",
  斯威士兰: "Eswatini",
  苏里南: "Surinam",
  苏丹: "Sudan",
  斯里兰卡: "Sri Lanka",
  西班牙: "Espanja",
  南非: "Etelä-Afrikka",
  索马里: "Somalia",
  所罗门群岛: "Salomonsaaret",
  斯洛文尼亚: "Slovenia",
  斯洛伐克: "Slovakia",
  "圣马丁岛（荷兰部分）": "Sint Maarten (hollantilainen osa)",
  新加坡: "Singapore",
  塞拉利昂: "Sierra Leone",
  塞舌尔: "Seychellit",
  塞尔维亚: "Serbia",
  塞内加尔: "Senegal",
  沙特阿拉伯: "Saudi-Arabia",
  圣多美和普林西比: "São Tomé ja Príncipe",
  圣马力诺: "San Marino",
  萨摩亚: "Samoa",
  圣克里斯托弗和尼维斯: "Saint Kitts ja Nevis",
  圣文森特和格林纳丁斯: "Saint Vincent ja Grenadiinit",
  圣彼埃尔和密克隆岛: "Saint-Pierre ja Miquelon",
  圣露西亚: "Saint Lucia",
  圣基茨和尼维斯: "Saint Kitts ja Nevis",
  卢旺达: "Ruanda",
  俄罗斯: "Venäjä",
  罗马尼亚: "Romania",
  留尼汪: "Réunion",
  刚果共和国: "Kongon tasavalta",
  卡塔尔: "Qatar",
  波多黎各: "Puerto Rico",
  葡萄牙: "Portugali",
  波兰: "Puola",
  菲律宾: "Filippiinit",
  秘鲁: "Peru",
  巴拉圭: "Paraguay",
  巴布亚新几内亚: "Papua-Uusi-Guinea",
  巴拿马: "Panama",
  巴勒斯坦: "Palestiina",
  帕劳: "Palau",
  巴基斯坦: "Pakistan",
  阿曼: "Oman",
  挪威: "Norja",
  尼日利亚: "Nigeria",
  尼日尔: "Niger",
  尼加拉瓜: "Nicaragua",
  新西兰: "Uusi-Seelanti",
  新喀里多尼亚: "Uusi-Kaledonia",
  荷属安德列斯群岛: "Alankomaiden Antillit",
  荷兰: "Alankomaat",
  尼泊尔: "Nepal",
  纳米比亚: "Namibia",
  缅甸: "Myanmar",
  莫桑比克: "Mosambik",
  摩洛哥: "Marokko",
  蒙特塞拉特岛: "Montserrat",
  黑山: "Montenegro",
  蒙古: "Mongolia",
  摩纳哥: "Monaco",
  摩尔多瓦: "Moldova",
  墨西哥: "Meksiko",
  马约特: "Mayotte",
  毛里求斯: "Mauritius",
  毛里塔尼亚: "Mauritania",
  马里亚纳群岛: "Mariaanit",
  马提尼克: "Martinique",
  马耳他: "Malta",
  马里: "Mali",
  马尔代夫: "Malediivit",
  马来西亚: "Malesia",
  马拉维: "Malawi",
  马达加斯加: "Madagaskar",
  马其顿: "Pohjois-Makedonia",
  中国澳门: "Macao",
  卢森堡: "Luxemburg",
  立陶宛: "Liettua",
  列支敦士登: "Liechtenstein",
  利比亚: "Libya",
  利比里亚: "Liberia",
  莱索托: "Lesotho",
  黎巴嫩: "Libanon",
  拉脱维亚: "Latvia",
  老挝: "Laos",
  吉尔吉斯斯坦: "Kirgisia",
  科威特: "Kuwait",
  基里巴斯: "Kiribati",
  肯尼亚: "Kenia",
  哈萨克斯坦: "Kazakstan",
  约旦: "Jordania",
  日本: "Japani",
  牙买加: "Jamaika",
  象牙海岸: "Norsunluurannikko",
  意大利: "Italia",
  以色列: "Israel",
  爱尔兰: "Irlanti",
  伊拉克: "Irak",
  伊朗: "Iran",
  印度尼西亚: "Indonesia",
  印度: "Intia",
  冰岛: "Islanti",
  匈牙利: "Unkari",
  中国香港: "Hongkong",
  洪都拉斯: "Honduras",
  海地: "Haiti",
  圭亚那: "Guyana",
  几内亚比绍共和国: "Guinea-Bissau",
  几内亚: "Guinea",
  危地马拉: "Guatemala",
  关岛: "Guam",
  瓜德罗普岛: "Guadeloupe",
  格林纳达: "Grenada",
  格陵兰岛: "Grönlanti",
  希腊: "Kreikka",
  直布罗陀: "Gibraltar",
  加纳: "Ghana",
  德国: "Saksa",
  格鲁吉亚: "Georgia",
  冈比亚: "Gambia",
  加蓬: "Gabon",
  法属波利尼西亚: "Ranskan Polynesia",
  法属圭亚那: "Ranskan Guayana",
  法国: "Ranska",
  芬兰: "Suomi",
  斐济: "Fidži",
  法罗群岛: "Färsaaret",
  埃塞俄比亚: "Etiopia",
  爱沙尼亚: "Viro",
  厄立特里亚: "Eritrea",
  赤道几内亚: "Päiväntasaajan Guinea",
  萨尔瓦多: "El Salvador",
  埃及: "Egypti",
  厄瓜多尔: "Ecuador",
  多米尼加共和国: "Dominikaaninen tasavalta",
  多米尼加: "Dominica",
  吉布提: "Djibouti",
  丹麦: "Tanska",
  捷克: "Tšekki",
  塞浦路斯: "Kypros",
  库拉索: "Curaçao",
  古巴: "Kuuba",
  克罗地亚: "Kroatia",
  哥斯达黎加: "Costa Rica",
  科特迪瓦: "Norsunluurannikko",
  库克群岛: "Cookinsaaret",
  科摩罗: "Komorit",
  哥伦比亚: "Kolumbia",
  智利: "Chile",
  乍得: "Tšad",
  中非共和国: "Keski-Afrikan tasavalta",
  佛得角: "Kap Verde",
  开曼群岛: "Caymansaaret",
  开普: "Cape",
  加拿大: "Kanada",
  喀麦隆: "Kamerun",
  柬埔寨: "Kambodža",
  布隆迪: "Burundi",
  布基纳法索: "Burkina Faso",
  保加利亚: "Bulgaria",
  文莱: "Brunei",
  巴西: "Brasilia",
  博茨瓦纳: "Botswana",
  波斯尼亚和黑塞哥维那: "Bosnia ja Hertsegovina",
  玻利维亚: "Bolivia",
  不丹: "Bhutan",
  百慕大群岛: "Bermuda",
  贝宁: "Benin",
  伯利兹: "Belize",
  比利时: "Belgia",
  白俄罗斯: "Valko-Venäjä",
  巴巴多斯: "Barbados",
  孟加拉国: "Bangladesh",
  巴林: "Bahrain",
  巴哈马: "Bahama",
  阿塞拜疆: "Azerbaidžan",
  奥地利: "Itävalta",
  澳大利亚: "Australia",
  阿鲁巴: "Aruba",
  亚美尼亚: "Armenia",
  阿根廷: "Argentiina",
  安提瓜和巴布达: "Antigua ja Barbuda",
  安圭拉: "Anguilla",
  安哥拉: "Angola",
  安道尔: "Andorra",
  美属萨摩亚: "Amerikan Samoa",
  阿尔及利亚: "Algeria",
  中国: "Kiina",
  余额不足: "Saldo ei riitä",
  最低购买: "Minimiosto",
  最高购买: "Maksimiosto",
  下单成功: "Tilaus tehty",
  平仓成功: "Positio suljettu",
  请输入正确的平仓数量: "Syötä kelvollinen suljettava määrä",
  加仓成功: "Position lisäys onnistui",
  请输入正确的加仓金额: "Syötä kelvollinen summa position lisäämiseksi",
  收藏成功: "Lisätty suosikkeihin",
  取消收藏成功: "Poistettu suosikeista",
  加密币永续: "Kryptovaluutan ikuinen",
  外汇永续: "Forexin ikuinen",
  期权账户: "Optiotili",
  快捷卖币: "Myy kryptoja nopeasti",

  托管资金: "Hallinnoidut varat",
  托管中: "Hallinnoitavana",
  预计日收益: "Arvioitu päivittäinen tuotto",
  累计收益: "Kokonaistuotto",
  周期: "Kesto",
  日收益: "Päivittäinen tuotto",
  限额: "Raja",
  立即托管: "Aloita hallinnointi nyt",
  "已鎖定 請聯繫客服": "Lukittu. Ota yhteyttä asiakaspalveluun.",
  产品列表: "Tuotelista",
  规则: "Säännöt",
  创建订单: "Luo tilaus",
  产品名称: "Tuotteen nimi",
  托管周期: "Hallinnointijakso",
  等级限制: "Tasorajoitus",
  托管金额: "Hallinnoitu summa",
  限额: "Raja",
  余额: "Saldo",
  购买日: "Ostopäivä",
  起息日: "Koron alkamispäivä",
  派息时间: "Osingonmaksuaika",
  每天: "Päivittäin",
  计息结束日: "Koron päättymispäivä",
  每日收益: "Päivittäinen tuotto",
  预计收益: "Arvioitu tuotto",
  "收益将自动发送至您的余额账户;":
    "Tuotto lähetetään automaattisesti tilisi saldolle;",
  "您的资金没有任何风险;": "Varasi eivät ole vaarassa;",
  "365*24小时不断地工作;": "Työskentelee 24/7, 365 päivää vuodessa;",
  托管中: "Hallinnoitavana",
  结束: "Päättynyt",
  今日收益: "Tämän päivän tuotto",
  剩余周期: "Jäljellä oleva aika",
  进行中: "Aktiivinen",
  已发放: "Maksettu",
  信誉分: "Luottamuspisteet",

  复制成功: "Kopioitu onnistuneesti",
  VIP权益: "VIP-edut",
  旧密码: "Vanha salasana",
  请输入旧密码: "Anna vanha salasana",
  "忘记旧密码请联系客服重置。":
    "Jos olet unohtanut vanhan salasanasi, ota yhteyttä asiakaspalveluun nollataksesi sen.",
  去升级: "Päivitä",
  描述: "Kuvaus",
  实际存款金额: "Todellinen talletussumma",
  升级礼金: "Päivitysbonus",
  隔夜利息: "Yön yli -korko (swap)",
  自动结算: "Automaattinen selvitys",
  等级规则: "Tasosäännöt",
  "WEB3.0币持有数据收益": "WEB3.0-kolikoiden hallussapidon data tuotto",
  总生产: "Kokonaistuotanto",
  有效节点: "Aktiiviset solmut",
  参与人: "Osallistujat",
  用户收益: "Käyttäjän tuotto",
  "流动性WEB3.0输出": "Likviditeetin WEB3.0-tuotos",
  总资产: "Kokonaisvarat",

  ETHAI持有数据收益: "ETHAI-omistustietojen tuotto",
  AI量化流动性: "AI-kvantitatiivinen likviditeetti",
  现货买入手续费: "Spot-ostopalkkio",
  现货支出: "Spot-meno",
  现货资金费率: "Spot-rahoituskorko",
  现货卖出手续费: "Spot-myyntipalkkio",
  现货收入: "Spot-tulo",
  外汇合约支出: "Valuuttatermiinisopimuksen meno",
  外汇合约买入手续费: "Valuuttatermiinisopimuksen ostopalkkio",
  外汇合约资金费率: "Valuuttatermiinisopimuksen rahoituskorko",
  外汇合约卖出手续费: "Valuuttatermiinisopimuksen myyntipalkkio",
  外汇合约收入: "Valuuttatermiinisopimuksen tulo",
  理财购买: "Sijoituspalvelun osto",
  VIP理财日收益: "VIP-sijoituspalvelun päivittäinen tuotto",
  VIP理财隔夜利息: "VIP-sijoituspalvelun yön yli -korko",
  VIP本金返还: "VIP-pääoman palautus",
  VIP彩金发放: "VIP-bonuksen maksu",
  VIP彩金抵扣: "VIP-bonuksen vähennys",
  隔夜利息: "Yön yli -korko",
  设置资产密码: "Aseta varojen salasana",

  锁仓挖矿: "Lukittu louhinta",
  一站式理财服务: "Yhden luukun rahoituspalvelu",
  产品: "Tuotteet",
  客服中心: "Asiakaspalvelukeskus",
  贷款: "Lainat",
  挖矿赚不停: "Ansaitse jatkuvasti louhinnalla",
  "锁仓挖矿是通过将USDT (USD:1USDT=1USD) 托管给平台超算力矿机，在平台矿池中进行挖矿收益。":
    "Lukittu louhinta tarkoittaa USDT:n (USD:1USDT=1USD) sijoittamista alustan huippuluokan louhintalaitteisiin, jolloin louhintatuotot kertyvät alustan louhintapoolissa.",
  产品优势: "Tuotteen edut",
  随存随取: "Talleta ja nosta milloin tahansa",
  锁仓周期: "Lukitusjakso",
  每日下发: "Päivittäinen jakelu",
  随机空投: "Satunnainen airdrop",
  "100%资金安全保障": "100% varojen turvallisuustakuu",
  "100%节假日收益不间断": "100% jatkuvat tuotot myös lomina",
  成功锁仓后当天产出:
    "Tuotto alkaa samana päivänä onnistuneen lukituksen jälkeen",
  关于违约金: "Sopimussakosta",
  "若您希望转出未到期的本金,则会产生违约金,违约金=违约结算比例*剩余天数*锁仓金额.":
    "Jos haluat nostaa pääoman ennen eräpäivää, peritään sopimussakko. Sakko = sopimusrikkomuksen prosentti × jäljellä olevat päivät × lukittu määrä.",
  "举例:此锁仓挖矿的违约结算比例为5%,剩余3天到期,锁仓金额为10000U《USDT/USD》,则违约金=5%*3*10000=1500U,实际退回本金为15000U-1500U":
    "Esimerkki: Tämän lukitun louhinnan sopimussakon osuus on 5 %, jäljellä 3 päivää eräpäivään ja lukittu määrä on 10000U (USDT/USD). Sakko = 5%×3×10000=1500U, ja todellinen palautettava pääoma on 15000U-1500U.",
  收益计算: "Tuoton laskenta",
  "平台有多种锁仓挖矿理财产品供使用者选择,收益计算如下,举例:":
    "Alusta tarjoaa useita lukittuja louhintatuotteita käyttäjille. Tuoton laskenta on seuraava, esimerkiksi:",
  "会员在平台锁仓10000U(USDT,USD),如选择了周期为7天,日产出为锁仓金额的0.7%~1.8%的理财产品,则每天产出如下":
    "Jos jäsen lukitsee 10000U (USDT, USD) alustalle ja valitsee 7 päivän tuotteen, jonka päivätuotto on 0,7%~1,8% lukitusta määrästä, päivätuotto on seuraava:",
  "最低:10000Ux0.7%=70U;": "Minimi: 10000U×0,7%=70U;",
  "最高:10000Ux1.8%=180U;": "Maksimi: 10000U×1,8%=180U;",
  "即7天后可获得490U~1260U的收益,收益每日下发,锁仓本金到期后,自动转入您的资金账户.":
    "7 päivän jälkeen tuotto on 490U~1260U. Tuotot maksetaan päivittäin, ja lukittu pääoma siirretään automaattisesti tilillesi eräpäivän jälkeen.",
  正在托管的资金: "Hoidossa olevat varat",
  签到: "Päivittäinen kirjautuminen",
  锁仓订单: "Lukitus-tilaukset",
  预计今日收益: "Arvioitu päivän tuotto",
  累计收益: "Kertynyt tuotto",
  托管中的订单: "Hoidossa olevat tilaukset",
  单笔最少: "Vähimmäismäärä per tilaus",
  单笔最多: "Enimmäismäärä per tilaus",
  日收益率: "Päivittäinen tuottoaste",
  说明: "Selitys",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出<br>3.当天的收益会统一在次日GMT+8时间00:00-00:10内派发.":
    "1. Tilastointiaika perustuu GMT+8-aikaan<br>2. Päivittäinen tuotto lasketaan kaikista selvitettyistä tilauksista klo 00:00–23:59 GMT+8 (paikallinen aika 00:00–23:59)<br>3. Päivän tuotot maksetaan seuraavana päivänä klo 00:00–00:10 GMT+8.",
  知道了: "Selvä",
  锁仓: "Lukitse",
  派息时间: "Tuoton maksuaika",
  每日: "Päivittäin",
  托管资金: "Hoidetut varat",
  到期返回: "Palautus eräpäivänä",
  提前赎回: "Ennenaikainen lunastus",
  预计收益: "Arvioitu tuotto",
  认购: "Merkintä",
  热门: "Suosittu",
  数字货币: "Digitaalivaluutat",
  贵金属: "Kalliometallit",
  大宗商品: "Hyödykkeet",
  持仓明细: "Positioiden tiedot",
  历史明细: "Historia",
  当前价: "Nykyinen hinta",
  "↑买涨": "↑ Osta nousua",
  "↓买跌": "↓ Osta laskua",
  显示全部: "Näytä kaikki",
  买入金额: "Ostosumma",
  方向: "Suunta",
  收益: "Tuotto",
  预期收益: "Odotettu tuotto",
  估用保证金: "Arvioitu vakuus",
  确认下单: "Vahvista toimeksianto",
  锁定: "Lukittu",
  账户总资产: "Tilin kokonaisvarat",
  明细: "Tiedot",
  今日收益: "Tämän päivän tuotto",
  仓位保证金: "Position vakuus",
  持有仓位: "Avoimet positiot",
  "锁定金额=所有锁仓挖矿中未完成订单的金额总和":
    "Lukittu määrä = kaikkien keskeneräisten lukittujen louhintatilausten summa",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出":
    "1. Tilastointi perustuu GMT+8-aikaan<br>2. Päivittäinen tuotto lasketaan kaikista selvitettyistä tilauksista klo 00:00–23:59 GMT+8 (paikallinen aika 00:00–23:59)",
  充值方式: "Talletustapa",
  银行汇款: "Pankkisiirto",
  "银行汇款请联系客服进行操作!":
    "Ota yhteyttä asiakaspalveluun pankkisiirtoa varten!",
  提款方式: "Nostotapa",
  "银行提款请联系客服进行操作!":
    "Ota yhteyttä asiakaspalveluun pankkisiirron nostoa varten!",
  资金明细: "Varojen tiedot",
  提现记录: "Nostohistoria",
  拒绝: "Hylätty",
  通过: "Hyväksytty",
  拒绝原因: "Hylkäyksen syy",

  消息公告: "Ilmoitukset",
  订单: "Tilaukset",
  个人中心: "Oma keskus",
  "未到期赎回需支付一定的违约金!":
    "Ennenaikaisesta lunastuksesta peritään sakkomaksu.",

  请输入区号: "Anna suuntanumero",
  "请选择国家/地区": "Valitse maa/alue",

  今日开盘: "Tämän päivän avaus",
  昨日收盘: "Eilinen sulkeminen",

  实名认证即送: "Saat heti henkilöllisyyden vahvistamisen jälkeen",
  立即认证: "Vahvista nyt",
  新用户礼包: "Uuden käyttäjän lahjapaketti",
  完成新人任务领取: "Suorita uuden käyttäjän tehtävät ja lunasta",
  认证: "Vahvista",
  时间周期: "Ajanjakso",
  支付金额: "Maksusumma",
  已平仓: "Suljettu",
  "MGBX 新用户欢迎礼包：每位用户最多可获得":
    "MGBX:n uusien käyttäjien tervetulopaketti: jokainen käyttäjä voi saada enintään",
  我已经阅读并同意: "Olen lukenut ja hyväksyn",
  隐私政策: "Tietosuojakäytäntö",

  放弃奖励离开: "Luovu palkinnosta ja poistu",
  继续注册: "Jatka rekisteröitymistä",
  分钟: "Minuuttia",

  "请先勾选隐私政策!": "Tutustu ensin tietosuojakäytäntöön!",

  添加其他到自选: "Lisää muita seurantalistalle",

  充值最高可得: "Tee lisänosto ja saat jopa 30 000 dollaria.",

  请输入格式正确的手机号: "Syötä kelvollinen matkapuhelinnumero.",

  收起: "Collapse",
  上传截图: "Upload screenshot",
  "*充值成功后必须上传充值截图，否则将视为无效存款。": "*After a successful recharge, you must upload the recharge screenshot; otherwise the deposit will be invalid.",
};
// 芬兰



// WEBPACK FOOTER //
// ./src/lang/fl.js